/** VERSION: 1.3.10. Please don't modify or unzip this content. It will be updated regularly **/
var BoostOTP = function (t) {
    var e = {};

    function i(n) {
        if (e[n]) return e[n].exports;
        var r = e[n] = {i: n, l: !1, exports: {}};
        return t[n].call(r.exports, r, r.exports, i), r.l = !0, r.exports
    }

    return i.m = t, i.c = e, i.d = function (t, e, n) {
        i.o(t, e) || Object.defineProperty(t, e, {enumerable: !0, get: n})
    }, i.r = function (t) {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {value: "Module"}), Object.defineProperty(t, "__esModule", {value: !0})
    }, i.t = function (t, e) {
        if (1 & e && (t = i(t)), 8 & e) return t;
        if (4 & e && "object" == typeof t && t && t.__esModule) return t;
        var n = Object.create(null);
        if (i.r(n), Object.defineProperty(n, "default", {
            enumerable: !0,
            value: t
        }), 2 & e && "string" != typeof t) for (var r in t) i.d(n, r, function (e) {
            return t[e]
        }.bind(null, r));
        return n
    }, i.n = function (t) {
        var e = t && t.__esModule ? function () {
            return t.default
        } : function () {
            return t
        };
        return i.d(e, "a", e), e
    }, i.o = function (t, e) {
        return Object.prototype.hasOwnProperty.call(t, e)
    }, i.p = "", i(i.s = 96)
}([function (t, e, i) {
    var n = i(1), r = i(25).f, o = i(8), a = i(30), s = i(47), l = i(70), c = i(101);
    t.exports = function (t, e) {
        var i, u, f, p, d, h = t.target, v = t.global, g = t.stat;
        if (i = v ? n : g ? n[h] || s(h, {}) : (n[h] || {}).prototype) for (u in e) {
            if (p = e[u], f = t.noTargetGet ? (d = r(i, u)) && d.value : i[u], !c(v ? u : h + (g ? "." : "#") + u, t.forced) && void 0 !== f) {
                if (typeof p == typeof f) continue;
                l(p, f)
            }
            (t.sham || f && f.sham) && o(p, "sham", !0), a(i, u, p, t)
        }
    }
}, function (t, e, i) {
    (function (e) {
        var i = function (t) {
            return t && t.Math == Math && t
        };
        t.exports = i("object" == typeof globalThis && globalThis) || i("object" == typeof window && window) || i("object" == typeof self && self) || i("object" == typeof e && e) || Function("return this")()
    }).call(this, i(98))
}, function (t, e) {
    t.exports = function (t) {
        try {
            return !!t()
        } catch (t) {
            return !0
        }
    }
}, function (t, e, i) {
    "use strict";
    i(34), i(80), i(81), i(35);

    function n(t, e) {
        for (var i = 0; i < e.length; i++) {
            var n = e[i];
            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n)
        }
    }

    var r = function () {
        function t() {
            !function (t, e) {
                if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
            }(this, t), this.isInit = !1, this.isRendered = !1, this.isBoundEvent = !1, this.children = [], this.parent = null, this.$element = null
        }

        var e, i, r;
        return e = t, (i = [{
            key: "refresh", value: function () {
                this._callAllInit(), this._callAllRender(), this._callAllBindEvents()
            }
        }, {
            key: "beforeInit", value: function () {
            }
        }, {
            key: "init", value: function () {
            }
        }, {
            key: "afterInit", value: function () {
            }
        }, {
            key: "isLoopThroughChild", value: function () {
                return !0
            }
        }, {
            key: "isRender", value: function () {
                return !0
            }
        }, {
            key: "beforeRender", value: function () {
            }
        }, {
            key: "render", value: function () {
            }
        }, {
            key: "afterRender", value: function () {
            }
        }, {
            key: "isBindEvents", value: function () {
                return !0
            }
        }, {
            key: "beforeBindEvents", value: function () {
            }
        }, {
            key: "bindEvents", value: function () {
            }
        }, {
            key: "afterBindEvents", value: function () {
            }
        }, {
            key: "addComponent", value: function (t) {
                t.parent = this, this.children.push(t)
            }
        }, {
            key: "removeComponent", value: function (t) {
                if (this.children && this.children.length > 0) {
                    var e = this.children.indexOf(t);
                    -1 !== e && this.children.splice(e, 1)
                }
            }
        }, {
            key: "_callAllInit", value: function () {
                this.isInit || (this.beforeInit(), this.init()), this.children && this.children.length > 0 && this.isLoopThroughChild() && this.children.forEach((function (t) {
                    t._callAllInit()
                })), this.isInit || (this.afterInit(), this.isInit = !0)
            }
        }, {
            key: "_callAllRender", value: function () {
                this.isRender() && this.beforeRender(), this.children && this.children.length > 0 && this.isLoopThroughChild() && this.children.forEach((function (t) {
                    t._callAllRender()
                })), this.isRender() && (this.render(), this.afterRender(), this.isRendered = !0)
            }
        }, {
            key: "_callAllBindEvents", value: function () {
                this.isBindEvents() && this.beforeBindEvents(), this.children && this.children.length > 0 && this.isLoopThroughChild() && this.children.forEach((function (t) {
                    t._callAllBindEvents()
                })), this.isBindEvents() && (this.bindEvents(), this.afterBindEvents(), this.isBoundEvent = !0)
            }
        }]) && n(e.prototype, i), r && n(e, r), t
    }();
    e.a = r
}, function (t, e) {
    var i = {}.hasOwnProperty;
    t.exports = function (t, e) {
        return i.call(t, e)
    }
}, function (t, e, i) {
    var n = i(1), r = i(48), o = i(4), a = i(49), s = i(54), l = i(76), c = r("wks"), u = n.Symbol,
        f = l ? u : u && u.withoutSetter || a;
    t.exports = function (t) {
        return o(c, t) || (s && o(u, t) ? c[t] = u[t] : c[t] = f("Symbol." + t)), c[t]
    }
}, function (t, e, i) {
    var n = i(2);
    t.exports = !n((function () {
        return 7 != Object.defineProperty({}, 1, {
            get: function () {
                return 7
            }
        })[1]
    }))
}, function (t, e) {
    t.exports = function (t) {
        return "object" == typeof t ? null !== t : "function" == typeof t
    }
}, function (t, e, i) {
    var n = i(6), r = i(9), o = i(28);
    t.exports = n ? function (t, e, i) {
        return r.f(t, e, o(1, i))
    } : function (t, e, i) {
        return t[e] = i, t
    }
}, function (t, e, i) {
    var n = i(6), r = i(66), o = i(10), a = i(38), s = Object.defineProperty;
    e.f = n ? s : function (t, e, i) {
        if (o(t), e = a(e, !0), o(i), r) try {
            return s(t, e, i)
        } catch (t) {
        }
        if ("get" in i || "set" in i) throw TypeError("Accessors not supported");
        return "value" in i && (t[e] = i.value), t
    }
}, function (t, e, i) {
    var n = i(7);
    t.exports = function (t) {
        if (!n(t)) throw TypeError(String(t) + " is not an object");
        return t
    }
}, function (t, e, i) {
    "use strict";
    var n = i(21), r = i(55), o = i(61), a = i(39), s = i(86), l = a.set, c = a.getterFor("Array Iterator");
    t.exports = s(Array, "Array", (function (t, e) {
        l(this, {type: "Array Iterator", target: n(t), index: 0, kind: e})
    }), (function () {
        var t = c(this), e = t.target, i = t.kind, n = t.index++;
        return !e || n >= e.length ? (t.target = void 0, {value: void 0, done: !0}) : "keys" == i ? {
            value: n,
            done: !1
        } : "values" == i ? {value: e[n], done: !1} : {value: [n, e[n]], done: !1}
    }), "values"), o.Arguments = o.Array, r("keys"), r("values"), r("entries")
}, function (t, e, i) {
    "use strict";
    var n = i(0), r = i(1), o = i(42), a = i(31), s = i(6), l = i(54), c = i(76), u = i(2), f = i(4), p = i(75),
        d = i(7), h = i(10), v = i(23), g = i(21), m = i(38), b = i(28), y = i(56), S = i(57), w = i(50), k = i(112),
        C = i(53), x = i(25), O = i(9), _ = i(45), P = i(8), T = i(30), E = i(48), j = i(40), $ = i(41), A = i(49),
        L = i(5), I = i(84), R = i(85), V = i(60), M = i(39), F = i(43).forEach, q = j("hidden"), B = L("toPrimitive"),
        D = M.set, W = M.getterFor("Symbol"), Q = Object.prototype, N = r.Symbol, U = o("JSON", "stringify"), z = x.f,
        G = O.f, X = k.f, H = _.f, J = E("symbols"), K = E("op-symbols"), Y = E("string-to-symbol-registry"),
        Z = E("symbol-to-string-registry"), tt = E("wks"), et = r.QObject,
        it = !et || !et.prototype || !et.prototype.findChild, nt = s && u((function () {
            return 7 != y(G({}, "a", {
                get: function () {
                    return G(this, "a", {value: 7}).a
                }
            })).a
        })) ? function (t, e, i) {
            var n = z(Q, e);
            n && delete Q[e], G(t, e, i), n && t !== Q && G(Q, e, n)
        } : G, rt = function (t, e) {
            var i = J[t] = y(N.prototype);
            return D(i, {type: "Symbol", tag: t, description: e}), s || (i.description = e), i
        }, ot = c ? function (t) {
            return "symbol" == typeof t
        } : function (t) {
            return Object(t) instanceof N
        }, at = function (t, e, i) {
            t === Q && at(K, e, i), h(t);
            var n = m(e, !0);
            return h(i), f(J, n) ? (i.enumerable ? (f(t, q) && t[q][n] && (t[q][n] = !1), i = y(i, {enumerable: b(0, !1)})) : (f(t, q) || G(t, q, b(1, {})), t[q][n] = !0), nt(t, n, i)) : G(t, n, i)
        }, st = function (t, e) {
            h(t);
            var i = g(e), n = S(i).concat(ft(i));
            return F(n, (function (e) {
                s && !lt.call(i, e) || at(t, e, i[e])
            })), t
        }, lt = function (t) {
            var e = m(t, !0), i = H.call(this, e);
            return !(this === Q && f(J, e) && !f(K, e)) && (!(i || !f(this, e) || !f(J, e) || f(this, q) && this[q][e]) || i)
        }, ct = function (t, e) {
            var i = g(t), n = m(e, !0);
            if (i !== Q || !f(J, n) || f(K, n)) {
                var r = z(i, n);
                return !r || !f(J, n) || f(i, q) && i[q][n] || (r.enumerable = !0), r
            }
        }, ut = function (t) {
            var e = X(g(t)), i = [];
            return F(e, (function (t) {
                f(J, t) || f($, t) || i.push(t)
            })), i
        }, ft = function (t) {
            var e = t === Q, i = X(e ? K : g(t)), n = [];
            return F(i, (function (t) {
                !f(J, t) || e && !f(Q, t) || n.push(J[t])
            })), n
        };
    (l || (T((N = function () {
        if (this instanceof N) throw TypeError("Symbol is not a constructor");
        var t = arguments.length && void 0 !== arguments[0] ? String(arguments[0]) : void 0, e = A(t),
            i = function (t) {
                this === Q && i.call(K, t), f(this, q) && f(this[q], e) && (this[q][e] = !1), nt(this, e, b(1, t))
            };
        return s && it && nt(Q, e, {configurable: !0, set: i}), rt(e, t)
    }).prototype, "toString", (function () {
        return W(this).tag
    })), T(N, "withoutSetter", (function (t) {
        return rt(A(t), t)
    })), _.f = lt, O.f = at, x.f = ct, w.f = k.f = ut, C.f = ft, I.f = function (t) {
        return rt(L(t), t)
    }, s && (G(N.prototype, "description", {
        configurable: !0, get: function () {
            return W(this).description
        }
    }), a || T(Q, "propertyIsEnumerable", lt, {unsafe: !0}))), n({
        global: !0,
        wrap: !0,
        forced: !l,
        sham: !l
    }, {Symbol: N}), F(S(tt), (function (t) {
        R(t)
    })), n({target: "Symbol", stat: !0, forced: !l}, {
        for: function (t) {
            var e = String(t);
            if (f(Y, e)) return Y[e];
            var i = N(e);
            return Y[e] = i, Z[i] = e, i
        }, keyFor: function (t) {
            if (!ot(t)) throw TypeError(t + " is not a symbol");
            if (f(Z, t)) return Z[t]
        }, useSetter: function () {
            it = !0
        }, useSimple: function () {
            it = !1
        }
    }), n({target: "Object", stat: !0, forced: !l, sham: !s}, {
        create: function (t, e) {
            return void 0 === e ? y(t) : st(y(t), e)
        }, defineProperty: at, defineProperties: st, getOwnPropertyDescriptor: ct
    }), n({target: "Object", stat: !0, forced: !l}, {
        getOwnPropertyNames: ut,
        getOwnPropertySymbols: ft
    }), n({
        target: "Object", stat: !0, forced: u((function () {
            C.f(1)
        }))
    }, {
        getOwnPropertySymbols: function (t) {
            return C.f(v(t))
        }
    }), U) && n({
        target: "JSON", stat: !0, forced: !l || u((function () {
            var t = N();
            return "[null]" != U([t]) || "{}" != U({a: t}) || "{}" != U(Object(t))
        }))
    }, {
        stringify: function (t, e, i) {
            for (var n, r = [t], o = 1; arguments.length > o;) r.push(arguments[o++]);
            if (n = e, (d(e) || void 0 !== t) && !ot(t)) return p(e) || (e = function (t, e) {
                if ("function" == typeof n && (e = n.call(this, t, e)), !ot(e)) return e
            }), r[1] = e, U.apply(null, r)
        }
    });
    N.prototype[B] || P(N.prototype, B, N.prototype.valueOf), V(N, "Symbol"), $[q] = !0
}, function (t, e, i) {
    "use strict";
    var n = i(0), r = i(6), o = i(1), a = i(4), s = i(7), l = i(9).f, c = i(70), u = o.Symbol;
    if (r && "function" == typeof u && (!("description" in u.prototype) || void 0 !== u().description)) {
        var f = {}, p = function () {
            var t = arguments.length < 1 || void 0 === arguments[0] ? void 0 : String(arguments[0]),
                e = this instanceof p ? new u(t) : void 0 === t ? u() : u(t);
            return "" === t && (f[e] = !0), e
        };
        c(p, u);
        var d = p.prototype = u.prototype;
        d.constructor = p;
        var h = d.toString, v = "Symbol(test)" == String(u("test")), g = /^Symbol\((.*)\)[^)]+$/;
        l(d, "description", {
            configurable: !0, get: function () {
                var t = s(this) ? this.valueOf() : this, e = h.call(t);
                if (a(f, t)) return "";
                var i = v ? e.slice(7, -1) : e.replace(g, "$1");
                return "" === i ? void 0 : i
            }
        }), n({global: !0, forced: !0}, {Symbol: p})
    }
}, function (t, e, i) {
    i(85)("iterator")
}, function (t, e, i) {
    var n = i(0), r = i(2), o = i(23), a = i(44), s = i(88);
    n({
        target: "Object", stat: !0, forced: r((function () {
            a(1)
        })), sham: !s
    }, {
        getPrototypeOf: function (t) {
            return a(o(t))
        }
    })
}, function (t, e, i) {
    i(0)({target: "Object", stat: !0}, {setPrototypeOf: i(89)})
}, function (t, e, i) {
    var n = i(62), r = i(30), o = i(115);
    n || r(Object.prototype, "toString", o, {unsafe: !0})
}, function (t, e, i) {
    "use strict";
    var n = i(90).charAt, r = i(39), o = i(86), a = r.set, s = r.getterFor("String Iterator");
    o(String, "String", (function (t) {
        a(this, {type: "String Iterator", string: String(t), index: 0})
    }), (function () {
        var t, e = s(this), i = e.string, r = e.index;
        return r >= i.length ? {value: void 0, done: !0} : (t = n(i, r), e.index += t.length, {value: t, done: !1})
    }))
}, function (t, e, i) {
    var n = i(1), r = i(83), o = i(11), a = i(8), s = i(5), l = s("iterator"), c = s("toStringTag"), u = o.values;
    for (var f in r) {
        var p = n[f], d = p && p.prototype;
        if (d) {
            if (d[l] !== u) try {
                a(d, l, u)
            } catch (t) {
                d[l] = u
            }
            if (d[c] || a(d, c, f), r[f]) for (var h in o) if (d[h] !== o[h]) try {
                a(d, h, o[h])
            } catch (t) {
                d[h] = o[h]
            }
        }
    }
}, function (t, e, i) {
    "use strict";
    var n = i(0), r = i(43).find, o = i(55), a = i(26), s = !0, l = a("find");
    "find" in [] && Array(1).find((function () {
        s = !1
    })), n({target: "Array", proto: !0, forced: s || !l}, {
        find: function (t) {
            return r(this, t, arguments.length > 1 ? arguments[1] : void 0)
        }
    }), o("find")
}, function (t, e, i) {
    var n = i(46), r = i(22);
    t.exports = function (t) {
        return n(r(t))
    }
}, function (t, e) {
    t.exports = function (t) {
        if (null == t) throw TypeError("Can't call method on " + t);
        return t
    }
}, function (t, e, i) {
    var n = i(22);
    t.exports = function (t) {
        return Object(n(t))
    }
}, function (t, e, i) {
    "use strict";
    i.r(e);
    i(12), i(13), i(14), i(20), i(34), i(58), i(11), i(15), i(16), i(17), i(131), i(18), i(35), i(19);
    var n = i(3), r = i(65);

    function o(t) {
        return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
            return typeof t
        } : function (t) {
            return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
        })(t)
    }

    function a(t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
    }

    function s(t, e) {
        for (var i = 0; i < e.length; i++) {
            var n = e[i];
            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n)
        }
    }

    function l(t, e) {
        return !e || "object" !== o(e) && "function" != typeof e ? function (t) {
            if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return t
        }(t) : e
    }

    function c(t) {
        return (c = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t)
        })(t)
    }

    function u(t, e) {
        return (u = Object.setPrototypeOf || function (t, e) {
            return t.__proto__ = e, t
        })(t, e)
    }

    var f = BoostPFS.jQ, p = function (t) {
        function e() {
            return a(this, e), l(this, c(e).apply(this, arguments))
        }

        var i, n, o;
        return function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
            t.prototype = Object.create(e && e.prototype, {
                constructor: {
                    value: t,
                    writable: !0,
                    configurable: !0
                }
            }), e && u(t, e)
        }(e, t), i = e, o = [{
            key: "ProductSliderType", get: function () {
                return {MOST_POPULAR: "most-popular", RECENTLY_VIEWED: "recently-viewed"}
            }
        }], (n = [{
            key: "getTemplate", value: function () {
                return '\n\t\t\t<div class="boost-pfs-product-slider">\n\t\t\t\t<div class="boost-pfs-product-slider-title"></div>\n\t\t\t\t<div class="boost-pfs-product-slider-inner">\n\t\t\t\t\t<div class="boost-pfs-product-slider-item-wrapper"></div>\n\t\t\t\t</div>\n\t\t\t\t<div class="boost-pfs-product-slider-nav">\n\t\t\t\t\t<div class="boost-pfs-product-slider-prev disabled"></div>\n            \t\t<div class="boost-pfs-product-slider-next"></div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t'
            }
        }, {
            key: "render", value: function () {
                var t = this;
                f(this.selector).length > 0 && (this.$element = f(this.getTemplate()), this.children.length > 0 && (this.$productSliderTitle = this.$element.find(".boost-pfs-product-slider-title"), this.$productSliderTitle.html("<h2>" + this.header + "</h2>"), this.$productSlider = this.$element.find(".boost-pfs-product-slider-item-wrapper"), this.children.forEach((function (e) {
                    t.$productSlider.append(e.$element)
                }))), f(this.selector).first().html("").append(this.$element))
            }
        }, {
            key: "bindEvents", value: function () {
                this.$element && this.initImageSlider()
            }
        }, {
            key: "setData", value: function (t, e) {
                var i = this;
                this.data = t, this.children = [], this.data.products.forEach((function (t) {
                    var e = new r.default;
                    e.setData(t), i.addComponent(e)
                })), e && this.refresh()
            }
        }, {
            key: "initImageSlider", value: function () {
                var t = this.$element.find(".boost-pfs-product-slider-item-wrapper"),
                    e = this.$element.find(".boost-pfs-product-slider-item"),
                    i = this.$element.find(".boost-pfs-product-slider-prev"),
                    n = this.$element.find(".boost-pfs-product-slider-next");
                0 != t.length && 0 != e.length && (this.imageSlider = {
                    $itemsWrapper: t,
                    $prev: i,
                    $next: n,
                    posX1: 0,
                    posX2: 0,
                    posInitial: 0,
                    posFinal: 0,
                    threshold: 50,
                    slidesLength: e.length,
                    slideSize: e[0].offsetWidth,
                    index: 0,
                    allowShift: !0,
                    isDragging: !1
                }, 0 == this.imageSlider.index && this.imageSlider.$prev.addClass("disabled"), (this.imageSlider.index == this.imageSlider.slidesLength - 1 || this.imageSlider.slidesLength <= this.productSliderRange) && this.imageSlider.$next.addClass("disabled"), this.imageSlider.$itemsWrapper.css("left", "0px"), this.imageSlider.slidesLength <= this.productSliderRange || (this.imageSlider.$itemsWrapper.on("mousedown", this.dragStart.bind(this)), this.imageSlider.$itemsWrapper.on("mousemove", this.dragAction.bind(this)), this.imageSlider.$itemsWrapper.on("mouseup", this.dragEnd.bind(this)), this.imageSlider.$itemsWrapper.on("touchstart", this.dragStart.bind(this)), this.imageSlider.$itemsWrapper.on("touchmove", this.dragAction.bind(this)), this.imageSlider.$itemsWrapper.on("touchend", this.dragEnd.bind(this)), this.imageSlider.$prev.on("click", this.shiftSlide.bind(this, null, -1)), this.imageSlider.$next.on("click", this.shiftSlide.bind(this, null, 1))))
            }
        }, {
            key: "dragStart", value: function (t) {
                t = t || window.event, this.imageSlider.posInitial = this.imageSlider.$itemsWrapper[0].offsetLeft;
                var e = t.type.includes("touch") ? t.originalEvent.touches[0].clientX : t.clientX;
                this.imageSlider.posX1 = e, this.imageSlider.isDragging = !0
            }
        }, {
            key: "dragAction", value: function (t) {
                if (this.imageSlider.isDragging) {
                    var e = (t = t || window.event).type.includes("touch") ? t.originalEvent.touches[0].clientX : t.clientX;
                    this.imageSlider.posX2 = this.imageSlider.posX1 - e, this.imageSlider.posX1 = e;
                    var i = this.imageSlider.$itemsWrapper[0].offsetLeft - this.imageSlider.posX2,
                        n = .2 * this.imageSlider.slideSize,
                        r = -this.imageSlider.slideSize * (this.imageSlider.slidesLength - this.productSliderRange) - n;
                    i > n ? i = n : i < r && (i = r), this.imageSlider.$itemsWrapper.css("left", i + "px")
                }
            }
        }, {
            key: "dragEnd", value: function (t) {
                if (this.imageSlider.isDragging) if (this.imageSlider.isDragging = !1, this.imageSlider.posFinal = this.imageSlider.$itemsWrapper[0].offsetLeft, this.imageSlider.posFinal - this.imageSlider.posInitial < -this.imageSlider.threshold) {
                    var e = Math.round(Math.abs(this.imageSlider.posFinal - this.imageSlider.posInitial) / this.imageSlider.slideSize);
                    this.shiftSlide(null, e)
                } else this.imageSlider.posFinal - this.imageSlider.posInitial > this.imageSlider.threshold ? (e = Math.round(Math.abs(this.imageSlider.posFinal - this.imageSlider.posInitial) / this.imageSlider.slideSize), this.shiftSlide(null, -1 * e)) : this.imageSlider.$itemsWrapper.css("left", this.imageSlider.posInitial + "px")
            }
        }, {
            key: "shiftSlide", value: function (t, e) {
                if (null == t && (t = this.imageSlider.index + e), this.imageSlider.allowShift) {
                    var i, n = this.imageSlider.$itemsWrapper.css("left");
                    t > -1 && t < this.imageSlider.slidesLength - this.productSliderRange + 1 ? (i = -1 * t * this.imageSlider.slideSize + "px", this.imageSlider.index = t) : i = -1 * this.imageSlider.index * this.imageSlider.slideSize + "px", n != i && (0 == this.imageSlider.index ? this.imageSlider.$prev.addClass("disabled") : this.imageSlider.$prev.removeClass("disabled"), this.imageSlider.index == this.imageSlider.slidesLength - this.productSliderRange ? this.imageSlider.$next.addClass("disabled") : this.imageSlider.$next.removeClass("disabled"), this.imageSlider.$itemsWrapper.addClass("boost-pfs-product-slider-shifting"), this.imageSlider.$itemsWrapper.css("left", i), this.imageSlider.allowShift = !1, setTimeout(this.afterShiftSlide.bind(this), 300))
                }
            }
        }, {
            key: "afterShiftSlide", value: function () {
                this.imageSlider.$itemsWrapper.removeClass("boost-pfs-product-slider-shifting"), this.imageSlider.allowShift = !0
            }
        }]) && s(i.prototype, n), o && s(i, o), e
    }(n.a);
    e.default = p
}, function (t, e, i) {
    var n = i(6), r = i(45), o = i(28), a = i(21), s = i(38), l = i(4), c = i(66), u = Object.getOwnPropertyDescriptor;
    e.f = n ? u : function (t, e) {
        if (t = a(t), e = s(e, !0), c) try {
            return u(t, e)
        } catch (t) {
        }
        if (l(t, e)) return o(!r.f.call(t, e), t[e])
    }
}, function (t, e, i) {
    var n = i(6), r = i(2), o = i(4), a = Object.defineProperty, s = {}, l = function (t) {
        throw t
    };
    t.exports = function (t, e) {
        if (o(s, t)) return s[t];
        e || (e = {});
        var i = [][t], c = !!o(e, "ACCESSORS") && e.ACCESSORS, u = o(e, 0) ? e[0] : l, f = o(e, 1) ? e[1] : void 0;
        return s[t] = !!i && !r((function () {
            if (c && !n) return !0;
            var t = {length: -1};
            c ? a(t, 1, {enumerable: !0, get: l}) : t[1] = 1, i.call(t, u, f)
        }))
    }
}, function (t, e, i) {
    "use strict";
    var n = i(0), r = i(63);
    n({target: "RegExp", proto: !0, forced: /./.exec !== r}, {exec: r})
}, function (t, e) {
    t.exports = function (t, e) {
        return {enumerable: !(1 & t), configurable: !(2 & t), writable: !(4 & t), value: e}
    }
}, function (t, e) {
    var i = {}.toString;
    t.exports = function (t) {
        return i.call(t).slice(8, -1)
    }
}, function (t, e, i) {
    var n = i(1), r = i(8), o = i(4), a = i(47), s = i(68), l = i(39), c = l.get, u = l.enforce,
        f = String(String).split("String");
    (t.exports = function (t, e, i, s) {
        var l = !!s && !!s.unsafe, c = !!s && !!s.enumerable, p = !!s && !!s.noTargetGet;
        "function" == typeof i && ("string" != typeof e || o(i, "name") || r(i, "name", e), u(i).source = f.join("string" == typeof e ? e : "")), t !== n ? (l ? !p && t[e] && (c = !0) : delete t[e], c ? t[e] = i : r(t, e, i)) : c ? t[e] = i : a(e, i)
    })(Function.prototype, "toString", (function () {
        return "function" == typeof this && c(this).source || s(this)
    }))
}, function (t, e) {
    t.exports = !1
}, function (t, e, i) {
    var n = i(33), r = Math.min;
    t.exports = function (t) {
        return t > 0 ? r(n(t), 9007199254740991) : 0
    }
}, function (t, e) {
    var i = Math.ceil, n = Math.floor;
    t.exports = function (t) {
        return isNaN(t = +t) ? 0 : (t > 0 ? n : i)(t)
    }
}, function (t, e, i) {
    "use strict";
    var n = i(0), r = i(78);
    n({target: "Array", proto: !0, forced: [].forEach != r}, {forEach: r})
}, function (t, e, i) {
    var n = i(1), r = i(83), o = i(78), a = i(8);
    for (var s in r) {
        var l = n[s], c = l && l.prototype;
        if (c && c.forEach !== o) try {
            a(c, "forEach", o)
        } catch (t) {
            c.forEach = o
        }
    }
}, function (t, e, i) {
    "use strict";
    var n = i(119), r = i(10), o = i(23), a = i(32), s = i(33), l = i(22), c = i(120), u = i(121), f = Math.max,
        p = Math.min, d = Math.floor, h = /\$([$&'`]|\d\d?|<[^>]*>)/g, v = /\$([$&'`]|\d\d?)/g;
    n("replace", 2, (function (t, e, i, n) {
        var g = n.REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE, m = n.REPLACE_KEEPS_$0, b = g ? "$" : "$0";
        return [function (i, n) {
            var r = l(this), o = null == i ? void 0 : i[t];
            return void 0 !== o ? o.call(i, r, n) : e.call(String(r), i, n)
        }, function (t, n) {
            if (!g && m || "string" == typeof n && -1 === n.indexOf(b)) {
                var o = i(e, t, this, n);
                if (o.done) return o.value
            }
            var l = r(t), d = String(this), h = "function" == typeof n;
            h || (n = String(n));
            var v = l.global;
            if (v) {
                var S = l.unicode;
                l.lastIndex = 0
            }
            for (var w = []; ;) {
                var k = u(l, d);
                if (null === k) break;
                if (w.push(k), !v) break;
                "" === String(k[0]) && (l.lastIndex = c(d, a(l.lastIndex), S))
            }
            for (var C, x = "", O = 0, _ = 0; _ < w.length; _++) {
                k = w[_];
                for (var P = String(k[0]), T = f(p(s(k.index), d.length), 0), E = [], j = 1; j < k.length; j++) E.push(void 0 === (C = k[j]) ? C : String(C));
                var $ = k.groups;
                if (h) {
                    var A = [P].concat(E, T, d);
                    void 0 !== $ && A.push($);
                    var L = String(n.apply(void 0, A))
                } else L = y(P, d, T, E, $, n);
                T >= O && (x += d.slice(O, T) + L, O = T + P.length)
            }
            return x + d.slice(O)
        }];

        function y(t, i, n, r, a, s) {
            var l = n + t.length, c = r.length, u = v;
            return void 0 !== a && (a = o(a), u = h), e.call(s, u, (function (e, o) {
                var s;
                switch (o.charAt(0)) {
                    case"$":
                        return "$";
                    case"&":
                        return t;
                    case"`":
                        return i.slice(0, n);
                    case"'":
                        return i.slice(l);
                    case"<":
                        s = a[o.slice(1, -1)];
                        break;
                    default:
                        var u = +o;
                        if (0 === u) return e;
                        if (u > c) {
                            var f = d(u / 10);
                            return 0 === f ? e : f <= c ? void 0 === r[f - 1] ? o.charAt(1) : r[f - 1] + o.charAt(1) : e
                        }
                        s = r[u - 1]
                }
                return void 0 === s ? "" : s
            }))
        }
    }))
}, function (t, e, i) {
    "use strict";
    i.r(e);
    i(12), i(13), i(14), i(20), i(34), i(11), i(15), i(16), i(17), i(27), i(18), i(36), i(35), i(19);
    var n = i(3), r = i(64);

    function o(t) {
        return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
            return typeof t
        } : function (t) {
            return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
        })(t)
    }

    function a(t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
    }

    function s(t, e) {
        for (var i = 0; i < e.length; i++) {
            var n = e[i];
            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n)
        }
    }

    function l(t, e) {
        return !e || "object" !== o(e) && "function" != typeof e ? function (t) {
            if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return t
        }(t) : e
    }

    function c(t) {
        return (c = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t)
        })(t)
    }

    function u(t, e) {
        return (u = Object.setPrototypeOf || function (t, e) {
            return t.__proto__ = e, t
        })(t, e)
    }

    var f = BoostPFS.jQ, p = BoostPFS.Labels, d = BoostPFS.Utils, h = BoostPFS.Selector, v = function (t) {
        function e() {
            return a(this, e), l(this, c(e).apply(this, arguments))
        }

        var i, n, o;
        return function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
            t.prototype = Object.create(e && e.prototype, {
                constructor: {
                    value: t,
                    writable: !0,
                    configurable: !0
                }
            }), e && u(t, e)
        }(e, t), i = e, o = [{
            key: "instance", get: function () {
                return g
            }
        }], (n = [{
            key: "init", value: function () {
                this.isFetchedCartData = !1, g = this, this.getCart()
            }
        }, {
            key: "getTemplate", value: function () {
                return '\n\t\t\t\n\t\t\t<div class="boost-pfs-minicart-wrapper boost-pfs-minicart-{{ajaxCartStyle}}-wrapper">\n\t\t\t\t<div class="boost-pfs-minicart-backdrop"></div>\n\t\t\t\t<div class="boost-pfs-minicart-container boost-pfs-minicart-container-{{ajaxCartStyle}}">\n\t\t\t\t\t<div class="boost-pfs-minicart-heading">\n\t\t\t\t\t\t<h3 class="boost-pfs-minicart-title">{{label.atcMiniCartShopingCartLabel}}</h3>\n\t\t\t\t\t\t<a title="Close" href="javascript:void(0)" class="boost-pfs-minicart-close">{{label.close}}</a>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="boost-pfs-minicart-content">\n\t\t\t\t\t\t<div class="boost-pfs-minicart-top">\n\t\t\t\t\t\t\t<div class="boost-pfs-minicart-empty">{{label.atcMiniCartEmptyCartLabel}}</div>\n\t\t\t\t\t\t\t<ol>{{cartItems}}</ol>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="boost-pfs-minicart-bottom">\n\t\t\t\t\t\t\t<div class="boost-pfs-count-item">{{countItem}} {{label.atcMiniCartCountItemLabel}}</div>\n\t\t\t\t\t\t\t<div class="boost-pfs-subtotal">\n\t\t\t\t\t\t\t\t<span class="boost-pfs-subtotal-label">{{label.atcMiniCartSubtotalLabel}}</span>\n\t\t\t\t\t\t\t\t<span class="boost-pfs-subtotal-price">{{subtotalPrice}}</span>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="boost-pfs-checkout">\n\t\t\t\t\t\t\t\t<button onclick="window.location=\'/checkout\'" class="boost-pfs-checkout-btn">{{label.atcMiniCartCheckoutLabel}}</button>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class="boost-pfs-viewcart">\n\t\t\t\t\t\t\t\t<a href="/cart">{{label.atcMiniCartViewCartLabel}}</a>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t'
            }
        }, {
            key: "compileTemplate", value: function () {
                var t = d.formatMoney(this.data.items_subtotal_price);
                return this.getTemplate().replace(/{{label.close}}/g, p.close).replace(/{{label.atcMiniCartEmptyCartLabel}}/g, p.action_list.atcMiniCartEmptyCartLabel).replace(/{{label.atcMiniCartShopingCartLabel}}/g, p.action_list.atcMiniCartShopingCartLabel).replace(/{{label.atcMiniCartCountItemLabel}}/g, p.action_list.atcMiniCartCountItemLabel).replace(/{{label.atcMiniCartSubtotalLabel}}/g, p.action_list.atcMiniCartSubtotalLabel).replace(/{{label.atcMiniCartCheckoutLabel}}/g, p.action_list.atcMiniCartCheckoutLabel).replace(/{{label.atcMiniCartViewCartLabel}}/g, p.action_list.atcMiniCartViewCartLabel).replace(/{{ajaxCartStyle}}/g, Settings.getSettingValue("general.ajaxCartStyle")).replace(/{{subtotalPrice}}/g, t).replace(/{{countItem}}/g, this.data.item_count).replace(/{{cartItems}}/g, "")
            }
        }, {
            key: "isRender", value: function () {
                return this.isFetchedCartData
            }
        }, {
            key: "render", value: function () {
                var t = this;
                this.$element || (this.$element = f(this.compileTemplate()), f("body").append(this.$element)), this.$element.find(".boost-pfs-minicart-top > ol").html(""), this.cartItems.forEach((function (e) {
                    e.$element && t.$element.find(".boost-pfs-minicart-top > ol").append(e.$element)
                })), 0 == this.cartItems.length ? (this.$element.find(".boost-pfs-minicart-empty").show(), this.$element.find(".boost-pfs-minicart-bottom").hide()) : (this.$element.find(".boost-pfs-minicart-empty").hide(), this.$element.find(".boost-pfs-minicart-bottom").show());
                var e = d.formatMoney(this.data.items_subtotal_price);
                this.$element.find(".boost-pfs-subtotal-price").html(e), h.otpTopCartSubtotal && f(h.otpTopCartSubtotal).length > 0 && f(h.otpTopCartSubtotal).html(e);
                var i = f(h.otpTopCartCount).html() || "0";
                f(h.otpTopCartCount).html(i.replace(/[0-9]+/, this.data.item_count)), this.data.item_count > 0 ? f(h.otpTopCartCount).removeClass("hide").removeClass("critical-hidden") : f(h.otpTopCartCount).addClass("hide");
                var n = this.$element.find(".boost-pfs-count-item").text();
                this.$element.find(".boost-pfs-count-item").html(n.replace(/[0-9]+/, this.data.item_count))
            }
        }, {
            key: "isBindEvents", value: function () {
                return this.isFetchedCartData
            }
        }, {
            key: "bindEvents", value: function () {
                this.$element && (f(h.otpTopCartLink).on("click", this.openAjaxCart.bind(this)), f(".boost-pfs-minicart-backdrop, .boost-pfs-minicart-close").on("click", this.closeAjaxCart.bind(this)))
            }
        }, {
            key: "getCart", value: function (t) {
                var e = this;
                f.ajax({
                    type: "GET", url: "/cart.js", dataType: "json", success: function (i) {
                        e.setData(i), t && e.openAjaxCart()
                    }
                })
            }
        }, {
            key: "addToCart", value: function (t, e, i, n) {
                var r = this;
                this.changeButtonLabel(i, p.action_list.atcAvailableLabel, p.action_list.atcAddingToCartBtnLabel), f.ajax({
                    type: "POST",
                    url: "/cart/add.js",
                    data: "quantity=" + e + "&id=" + t,
                    dataType: "json",
                    success: function (t) {
                        r.onSucess(t, i, n)
                    },
                    error: function (t) {
                        r.onError(t, i, n)
                    }
                })
            }
        }, {
            key: "removeFromCart", value: function (t) {
                var e = this;
                f.ajax({
                    type: "POST",
                    url: "/cart/change.js",
                    data: "quantity=0&id=" + t,
                    dataType: "json",
                    success: function (t) {
                        e.onSucess(t)
                    },
                    error: function (t) {
                        e.onError(t)
                    }
                })
            }
        }, {
            key: "onSucess", value: function (t, e, i) {
                var n = this;
                this.changeButtonLabel(e, p.action_list.atcAddingToCartBtnLabel, p.action_list.atcAddedToCartBtnLabel), setTimeout((function () {
                    n.changeButtonLabel(e, p.action_list.atcAddedToCartBtnLabel, p.action_list.atcAvailableLabel)
                }), 700);
                var r = Settings.getSettingValue("general.showAjaxCartOnAdd");
                this.getCart(r)
            }
        }, {
            key: "onError", value: function (t, e, i) {
                var n = this;
                this.changeButtonLabel(e, p.action_list.atcAddingToCartBtnLabel, p.action_list.atcAvailableLabel);
                var r = "";
                "422" == t.status ? r = t.responseJSON.description : console.log("ajaxAddToCart: " + t.status), i && i.length > 0 ? (this.changeButtonLabel(i, null, r), setTimeout((function () {
                    n.changeButtonLabel(i, null, "")
                }), 2e3)) : r && alert(r)
            }
        }, {
            key: "changeButtonLabel", value: function (t, e, i) {
                if (t) if (e) {
                    var n = t.html().toLowerCase().replace(e.toLowerCase(), i);
                    t.html(n)
                } else t.html(i)
            }
        }, {
            key: "openAjaxCart", value: function (t) {
                t && t.preventDefault(), f(".boost-pfs-quickview-close").length > 0 && f(".boost-pfs-quickview-close").click(), this.$element.show(), this.$element.addClass("boost-pfs-minicart-active"), Settings.getSettingValue("general.autoCloseMiniCart") && (this.$element.delay(Settings.getSettingValue("general.autoCloseMiniCartDuration")).fadeOut(Settings.getSettingValue("general.autoCloseMiniCartDuration")), f("body").removeClass("boost-pfs-body-no-scroll"), f("html").removeClass("boost-pfs-body-no-scroll")), f("body").addClass("boost-pfs-body-no-scroll"), f("html").addClass("boost-pfs-body-no-scroll")
            }
        }, {
            key: "closeAjaxCart", value: function (t) {
                var e = f(t.target);
                (e.hasClass("boost-pfs-minicart-backdrop") || e.hasClass("boost-pfs-minicart-close")) && (this.$element.find(".boost-pfs-minicart-wrapper").removeClass("boost-pfs-minicart-active"), this.$element.hide(), f("body").removeClass("boost-pfs-body-no-scroll"), f("html").removeClass("boost-pfs-body-no-scroll"))
            }
        }, {
            key: "setData", value: function (t) {
                var e = this;
                this.isFetchedCartData = !0, t.original_total_price /= 100, t.total_price /= 100, t.total_discount /= 100, t.items_subtotal_price /= 100, this.children = [], this.cartItems = [], t.items.forEach((function (t) {
                    t.price /= 100, t.original_price /= 100, t.discounted_price /= 100, t.line_price /= 100, t.original_line_price /= 100, t.final_price /= 100, t.final_line_price /= 100, t.line_level_total_discount /= 100;
                    var i = new r.default;
                    i.setData(t), e.addComponent(i), e.cartItems.push(i)
                })), this.data = t, this.refresh()
            }
        }]) && s(i.prototype, n), o && s(i, o), e
    }(n.a), g = null;
    e.default = v
}, function (t, e, i) {
    var n = i(7);
    t.exports = function (t, e) {
        if (!n(t)) return t;
        var i, r;
        if (e && "function" == typeof (i = t.toString) && !n(r = i.call(t))) return r;
        if ("function" == typeof (i = t.valueOf) && !n(r = i.call(t))) return r;
        if (!e && "function" == typeof (i = t.toString) && !n(r = i.call(t))) return r;
        throw TypeError("Can't convert object to primitive value")
    }
}, function (t, e, i) {
    var n, r, o, a = i(99), s = i(1), l = i(7), c = i(8), u = i(4), f = i(40), p = i(41), d = s.WeakMap;
    if (a) {
        var h = new d, v = h.get, g = h.has, m = h.set;
        n = function (t, e) {
            return m.call(h, t, e), e
        }, r = function (t) {
            return v.call(h, t) || {}
        }, o = function (t) {
            return g.call(h, t)
        }
    } else {
        var b = f("state");
        p[b] = !0, n = function (t, e) {
            return c(t, b, e), e
        }, r = function (t) {
            return u(t, b) ? t[b] : {}
        }, o = function (t) {
            return u(t, b)
        }
    }
    t.exports = {
        set: n, get: r, has: o, enforce: function (t) {
            return o(t) ? r(t) : n(t, {})
        }, getterFor: function (t) {
            return function (e) {
                var i;
                if (!l(e) || (i = r(e)).type !== t) throw TypeError("Incompatible receiver, " + t + " required");
                return i
            }
        }
    }
}, function (t, e, i) {
    var n = i(48), r = i(49), o = n("keys");
    t.exports = function (t) {
        return o[t] || (o[t] = r(t))
    }
}, function (t, e) {
    t.exports = {}
}, function (t, e, i) {
    var n = i(71), r = i(1), o = function (t) {
        return "function" == typeof t ? t : void 0
    };
    t.exports = function (t, e) {
        return arguments.length < 2 ? o(n[t]) || o(r[t]) : n[t] && n[t][e] || r[t] && r[t][e]
    }
}, function (t, e, i) {
    var n = i(102), r = i(46), o = i(23), a = i(32), s = i(74), l = [].push, c = function (t) {
        var e = 1 == t, i = 2 == t, c = 3 == t, u = 4 == t, f = 6 == t, p = 5 == t || f;
        return function (d, h, v, g) {
            for (var m, b, y = o(d), S = r(y), w = n(h, v, 3), k = a(S.length), C = 0, x = g || s, O = e ? x(d, k) : i ? x(d, 0) : void 0; k > C; C++) if ((p || C in S) && (b = w(m = S[C], C, y), t)) if (e) O[C] = b; else if (b) switch (t) {
                case 3:
                    return !0;
                case 5:
                    return m;
                case 6:
                    return C;
                case 2:
                    l.call(O, m)
            } else if (u) return !1;
            return f ? -1 : c || u ? u : O
        }
    };
    t.exports = {forEach: c(0), map: c(1), filter: c(2), some: c(3), every: c(4), find: c(5), findIndex: c(6)}
}, function (t, e, i) {
    var n = i(4), r = i(23), o = i(40), a = i(88), s = o("IE_PROTO"), l = Object.prototype;
    t.exports = a ? Object.getPrototypeOf : function (t) {
        return t = r(t), n(t, s) ? t[s] : "function" == typeof t.constructor && t instanceof t.constructor ? t.constructor.prototype : t instanceof Object ? l : null
    }
}, function (t, e, i) {
    "use strict";
    var n = {}.propertyIsEnumerable, r = Object.getOwnPropertyDescriptor, o = r && !n.call({1: 2}, 1);
    e.f = o ? function (t) {
        var e = r(this, t);
        return !!e && e.enumerable
    } : n
}, function (t, e, i) {
    var n = i(2), r = i(29), o = "".split;
    t.exports = n((function () {
        return !Object("z").propertyIsEnumerable(0)
    })) ? function (t) {
        return "String" == r(t) ? o.call(t, "") : Object(t)
    } : Object
}, function (t, e, i) {
    var n = i(1), r = i(8);
    t.exports = function (t, e) {
        try {
            r(n, t, e)
        } catch (i) {
            n[t] = e
        }
        return e
    }
}, function (t, e, i) {
    var n = i(31), r = i(69);
    (t.exports = function (t, e) {
        return r[t] || (r[t] = void 0 !== e ? e : {})
    })("versions", []).push({
        version: "3.6.4",
        mode: n ? "pure" : "global",
        copyright: "© 2020 Denis Pushkarev (zloirock.ru)"
    })
}, function (t, e) {
    var i = 0, n = Math.random();
    t.exports = function (t) {
        return "Symbol(" + String(void 0 === t ? "" : t) + ")_" + (++i + n).toString(36)
    }
}, function (t, e, i) {
    var n = i(72), r = i(52).concat("length", "prototype");
    e.f = Object.getOwnPropertyNames || function (t) {
        return n(t, r)
    }
}, function (t, e, i) {
    var n = i(21), r = i(32), o = i(73), a = function (t) {
        return function (e, i, a) {
            var s, l = n(e), c = r(l.length), u = o(a, c);
            if (t && i != i) {
                for (; c > u;) if ((s = l[u++]) != s) return !0
            } else for (; c > u; u++) if ((t || u in l) && l[u] === i) return t || u || 0;
            return !t && -1
        }
    };
    t.exports = {includes: a(!0), indexOf: a(!1)}
}, function (t, e) {
    t.exports = ["constructor", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "toLocaleString", "toString", "valueOf"]
}, function (t, e) {
    e.f = Object.getOwnPropertySymbols
}, function (t, e, i) {
    var n = i(2);
    t.exports = !!Object.getOwnPropertySymbols && !n((function () {
        return !String(Symbol())
    }))
}, function (t, e, i) {
    var n = i(5), r = i(56), o = i(9), a = n("unscopables"), s = Array.prototype;
    null == s[a] && o.f(s, a, {configurable: !0, value: r(null)}), t.exports = function (t) {
        s[a][t] = !0
    }
}, function (t, e, i) {
    var n, r = i(10), o = i(104), a = i(52), s = i(41), l = i(105), c = i(67), u = i(40), f = u("IE_PROTO"),
        p = function () {
        }, d = function (t) {
            return "<script>" + t + "<\/script>"
        }, h = function () {
            try {
                n = document.domain && new ActiveXObject("htmlfile")
            } catch (t) {
            }
            var t, e;
            h = n ? function (t) {
                t.write(d("")), t.close();
                var e = t.parentWindow.Object;
                return t = null, e
            }(n) : ((e = c("iframe")).style.display = "none", l.appendChild(e), e.src = String("javascript:"), (t = e.contentWindow.document).open(), t.write(d("document.F=Object")), t.close(), t.F);
            for (var i = a.length; i--;) delete h.prototype[a[i]];
            return h()
        };
    s[f] = !0, t.exports = Object.create || function (t, e) {
        var i;
        return null !== t ? (p.prototype = r(t), i = new p, p.prototype = null, i[f] = t) : i = h(), void 0 === e ? i : o(i, e)
    }
}, function (t, e, i) {
    var n = i(72), r = i(52);
    t.exports = Object.keys || function (t) {
        return n(t, r)
    }
}, function (t, e, i) {
    "use strict";
    var n = i(0), r = i(51).includes, o = i(55);
    n({target: "Array", proto: !0, forced: !i(26)("indexOf", {ACCESSORS: !0, 1: 0})}, {
        includes: function (t) {
            return r(this, t, arguments.length > 1 ? arguments[1] : void 0)
        }
    }), o("includes")
}, function (t, e) {
    t.exports = "\t\n\v\f\r                　\u2028\u2029\ufeff"
}, function (t, e, i) {
    var n = i(9).f, r = i(4), o = i(5)("toStringTag");
    t.exports = function (t, e, i) {
        t && !r(t = i ? t : t.prototype, o) && n(t, o, {configurable: !0, value: e})
    }
}, function (t, e) {
    t.exports = {}
}, function (t, e, i) {
    var n = {};
    n[i(5)("toStringTag")] = "z", t.exports = "[object z]" === String(n)
}, function (t, e, i) {
    "use strict";
    var n, r, o = i(117), a = i(118), s = RegExp.prototype.exec, l = String.prototype.replace, c = s,
        u = (n = /a/, r = /b*/g, s.call(n, "a"), s.call(r, "a"), 0 !== n.lastIndex || 0 !== r.lastIndex),
        f = a.UNSUPPORTED_Y || a.BROKEN_CARET, p = void 0 !== /()??/.exec("")[1];
    (u || p || f) && (c = function (t) {
        var e, i, n, r, a = this, c = f && a.sticky, d = o.call(a), h = a.source, v = 0, g = t;
        return c && (-1 === (d = d.replace("y", "")).indexOf("g") && (d += "g"), g = String(t).slice(a.lastIndex), a.lastIndex > 0 && (!a.multiline || a.multiline && "\n" !== t[a.lastIndex - 1]) && (h = "(?: " + h + ")", g = " " + g, v++), i = new RegExp("^(?:" + h + ")", d)), p && (i = new RegExp("^" + h + "$(?!\\s)", d)), u && (e = a.lastIndex), n = s.call(c ? i : a, g), c ? n ? (n.input = n.input.slice(v), n[0] = n[0].slice(v), n.index = a.lastIndex, a.lastIndex += n[0].length) : a.lastIndex = 0 : u && n && (a.lastIndex = a.global ? n.index + n[0].length : e), p && n && n.length > 1 && l.call(n[0], i, (function () {
            for (r = 1; r < arguments.length - 2; r++) void 0 === arguments[r] && (n[r] = void 0)
        })), n
    }), t.exports = c
}, function (t, e, i) {
    "use strict";
    i.r(e);
    i(12), i(13), i(14), i(20), i(11), i(15), i(16), i(17), i(27), i(18), i(36), i(19);
    var n = i(3);

    function r(t) {
        return (r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
            return typeof t
        } : function (t) {
            return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
        })(t)
    }

    function o(t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
    }

    function a(t, e) {
        for (var i = 0; i < e.length; i++) {
            var n = e[i];
            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n)
        }
    }

    function s(t, e) {
        return !e || "object" !== r(e) && "function" != typeof e ? function (t) {
            if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return t
        }(t) : e
    }

    function l(t) {
        return (l = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t)
        })(t)
    }

    function c(t, e) {
        return (c = Object.setPrototypeOf || function (t, e) {
            return t.__proto__ = e, t
        })(t, e)
    }

    var u = BoostPFS.jQ, f = (BoostPFS.Labels, BoostPFS.Utils), p = function (t) {
        function e() {
            return o(this, e), s(this, l(e).apply(this, arguments))
        }

        var i, n, r;
        return function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
            t.prototype = Object.create(e && e.prototype, {
                constructor: {
                    value: t,
                    writable: !0,
                    configurable: !0
                }
            }), e && c(t, e)
        }(e, t), i = e, (n = [{
            key: "getTemplate", value: function () {
                return '\n\t\t\t<li class="boost-pfs-minicart-item">\n\t\t\t\t<a href="{{variantUrl}}" title="{{productTitle}}" class="boost-pfs-minicart-item-image">\n\t\t\t\t\t<img src="{{variantImage}}" alt="{{productTitle}}">\n\t\t\t\t</a>\n\t\t\t\t<div class="boost-pfs-minicart-item-details">\n\t\t\t\t\t<div title="Remove this item" class="boost-pfs-minicart-item-remove">×</div>\n\t\t\t\t\t<p class="boost-pfs-minicart-item-name">\n\t\t\t\t\t\t<a href="{{variantUrl}}">{{productTitle}}</a>\n\t\t\t\t\t</p>\n\t\t\t\t\t<p class="boost-pfs-minicart-item-vendor">{{vendor}}</p>\n\t\t\t\t\t<div class="boost-pfs-minicart-item-options">{{variantTitle}}</div>\n\t\t\t\t\t<div class="boost-pfs-minicart-item-collateral">{{quantity}} x <span class="boost-pfs-minicart-item-price"><span class="money">{{price}}</span></span></div>\n\t\t\t\t</div>\n\t\t\t</li>\n\t\t'
            }
        }, {
            key: "compileTemplate", value: function () {
                var t = this.data.image ? this.data.image : this.data.featured_image && this.data.featured_image.url ? this.data.featured_image.url : boostPFSConfig.general.no_image_url;
                return this.getTemplate().replace(/{{variantUrl}}/g, this.data.url).replace(/{{productTitle}}/g, this.data.product_title).replace(/{{vendor}}/g, this.data.vendor).replace(/{{variantImage}}/g, t).replace(/{{variantTitle}}/g, this.data.variant_title ? this.data.variant_title : "").replace(/{{quantity}}/g, this.data.quantity).replace(/{{price}}/g, f.formatMoney(this.data.line_price))
            }
        }, {
            key: "isRender", value: function () {
                return this.parent.isFetchedCartData
            }
        }, {
            key: "render", value: function () {
                this.$element || (this.$element = u(this.compileTemplate()))
            }
        }, {
            key: "isBindEvents", value: function () {
                return this.parent.isFetchedCartData
            }
        }, {
            key: "bindEvents", value: function () {
                this.$element && this.$element.find(".boost-pfs-minicart-item-remove").on("click", this.onClickRemoveItem.bind(this))
            }
        }, {
            key: "onClickRemoveItem", value: function (t) {
                t && t.preventDefault(), this.parent.removeFromCart(this.data.variant_id)
            }
        }, {
            key: "setData", value: function (t) {
                this.data = t
            }
        }]) && a(i.prototype, n), r && a(i, r), e
    }(n.a);
    e.default = p
}, function (t, e, i) {
    "use strict";
    i.r(e);
    i(12), i(13), i(14), i(11), i(15), i(16), i(17), i(18), i(19);
    var n = i(3);

    function r(t) {
        return (r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
            return typeof t
        } : function (t) {
            return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
        })(t)
    }

    function o(t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
    }

    function a(t, e) {
        for (var i = 0; i < e.length; i++) {
            var n = e[i];
            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n)
        }
    }

    function s(t, e) {
        return !e || "object" !== r(e) && "function" != typeof e ? function (t) {
            if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return t
        }(t) : e
    }

    function l(t) {
        return (l = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t)
        })(t)
    }

    function c(t, e) {
        return (c = Object.setPrototypeOf || function (t, e) {
            return t.__proto__ = e, t
        })(t, e)
    }

    var u = BoostPFS.jQ, f = BoostPFS.Utils, p = function (t) {
        function e() {
            return o(this, e), s(this, l(e).apply(this, arguments))
        }

        var i, n, r;
        return function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
            t.prototype = Object.create(e && e.prototype, {
                constructor: {
                    value: t,
                    writable: !0,
                    configurable: !0
                }
            }), e && c(t, e)
        }(e, t), i = e, (n = [{
            key: "compileTemplate", value: function () {
                if ("function" == typeof ProductGridItem) {
                    var t = new ProductGridItem;
                    return t.data = this.data, t.compileTemplate()
                }
                throw Error("Missing buildProductGridItem function in theme lib")
            }
        }, {
            key: "render", value: function () {
                if (!this.$element) {
                    this.$element = u(this.compileTemplate()), this.$element.addClass("boost-pfs-product-slider-item"), f.isMobile() && (this.parent.productSliderRange = 2);
                    var t = u(".boost-pfs-most-popular").width() / this.parent.productSliderRange;
                    this.$element.css({width: t + "px"})
                }
            }
        }, {
            key: "setData", value: function (t) {
                this.data = t
            }
        }]) && a(i.prototype, n), r && a(i, r), e
    }(n.a);
    e.default = p
}, function (t, e, i) {
    var n = i(6), r = i(2), o = i(67);
    t.exports = !n && !r((function () {
        return 7 != Object.defineProperty(o("div"), "a", {
            get: function () {
                return 7
            }
        }).a
    }))
}, function (t, e, i) {
    var n = i(1), r = i(7), o = n.document, a = r(o) && r(o.createElement);
    t.exports = function (t) {
        return a ? o.createElement(t) : {}
    }
}, function (t, e, i) {
    var n = i(69), r = Function.toString;
    "function" != typeof n.inspectSource && (n.inspectSource = function (t) {
        return r.call(t)
    }), t.exports = n.inspectSource
}, function (t, e, i) {
    var n = i(1), r = i(47), o = n["__core-js_shared__"] || r("__core-js_shared__", {});
    t.exports = o
}, function (t, e, i) {
    var n = i(4), r = i(100), o = i(25), a = i(9);
    t.exports = function (t, e) {
        for (var i = r(e), s = a.f, l = o.f, c = 0; c < i.length; c++) {
            var u = i[c];
            n(t, u) || s(t, u, l(e, u))
        }
    }
}, function (t, e, i) {
    var n = i(1);
    t.exports = n
}, function (t, e, i) {
    var n = i(4), r = i(21), o = i(51).indexOf, a = i(41);
    t.exports = function (t, e) {
        var i, s = r(t), l = 0, c = [];
        for (i in s) !n(a, i) && n(s, i) && c.push(i);
        for (; e.length > l;) n(s, i = e[l++]) && (~o(c, i) || c.push(i));
        return c
    }
}, function (t, e, i) {
    var n = i(33), r = Math.max, o = Math.min;
    t.exports = function (t, e) {
        var i = n(t);
        return i < 0 ? r(i + e, 0) : o(i, e)
    }
}, function (t, e, i) {
    var n = i(7), r = i(75), o = i(5)("species");
    t.exports = function (t, e) {
        var i;
        return r(t) && ("function" != typeof (i = t.constructor) || i !== Array && !r(i.prototype) ? n(i) && null === (i = i[o]) && (i = void 0) : i = void 0), new (void 0 === i ? Array : i)(0 === e ? 0 : e)
    }
}, function (t, e, i) {
    var n = i(29);
    t.exports = Array.isArray || function (t) {
        return "Array" == n(t)
    }
}, function (t, e, i) {
    var n = i(54);
    t.exports = n && !Symbol.sham && "symbol" == typeof Symbol.iterator
}, function (t, e, i) {
    var n = i(22), r = "[" + i(59) + "]", o = RegExp("^" + r + r + "*"), a = RegExp(r + r + "*$"), s = function (t) {
        return function (e) {
            var i = String(n(e));
            return 1 & t && (i = i.replace(o, "")), 2 & t && (i = i.replace(a, "")), i
        }
    };
    t.exports = {start: s(1), end: s(2), trim: s(3)}
}, function (t, e, i) {
    "use strict";
    var n = i(43).forEach, r = i(79), o = i(26), a = r("forEach"), s = o("forEach");
    t.exports = a && s ? [].forEach : function (t) {
        return n(this, t, arguments.length > 1 ? arguments[1] : void 0)
    }
}, function (t, e, i) {
    "use strict";
    var n = i(2);
    t.exports = function (t, e) {
        var i = [][t];
        return !!i && n((function () {
            i.call(null, e || function () {
                throw 1
            }, 1)
        }))
    }
}, function (t, e, i) {
    "use strict";
    var n = i(0), r = i(51).indexOf, o = i(79), a = i(26), s = [].indexOf, l = !!s && 1 / [1].indexOf(1, -0) < 0,
        c = o("indexOf"), u = a("indexOf", {ACCESSORS: !0, 1: 0});
    n({target: "Array", proto: !0, forced: l || !c || !u}, {
        indexOf: function (t) {
            return l ? s.apply(this, arguments) || 0 : r(this, t, arguments.length > 1 ? arguments[1] : void 0)
        }
    })
}, function (t, e, i) {
    "use strict";
    var n = i(0), r = i(73), o = i(33), a = i(32), s = i(23), l = i(74), c = i(108), u = i(82), f = i(26),
        p = u("splice"), d = f("splice", {ACCESSORS: !0, 0: 0, 1: 2}), h = Math.max, v = Math.min;
    n({target: "Array", proto: !0, forced: !p || !d}, {
        splice: function (t, e) {
            var i, n, u, f, p, d, g = s(this), m = a(g.length), b = r(t, m), y = arguments.length;
            if (0 === y ? i = n = 0 : 1 === y ? (i = 0, n = m - b) : (i = y - 2, n = v(h(o(e), 0), m - b)), m + i - n > 9007199254740991) throw TypeError("Maximum allowed length exceeded");
            for (u = l(g, n), f = 0; f < n; f++) (p = b + f) in g && c(u, f, g[p]);
            if (u.length = n, i < n) {
                for (f = b; f < m - n; f++) d = f + i, (p = f + n) in g ? g[d] = g[p] : delete g[d];
                for (f = m; f > m - n + i; f--) delete g[f - 1]
            } else if (i > n) for (f = m - n; f > b; f--) d = f + i - 1, (p = f + n - 1) in g ? g[d] = g[p] : delete g[d];
            for (f = 0; f < i; f++) g[f + b] = arguments[f + 2];
            return g.length = m - n + i, u
        }
    })
}, function (t, e, i) {
    var n = i(2), r = i(5), o = i(109), a = r("species");
    t.exports = function (t) {
        return o >= 51 || !n((function () {
            var e = [];
            return (e.constructor = {})[a] = function () {
                return {foo: 1}
            }, 1 !== e[t](Boolean).foo
        }))
    }
}, function (t, e) {
    t.exports = {
        CSSRuleList: 0,
        CSSStyleDeclaration: 0,
        CSSValueList: 0,
        ClientRectList: 0,
        DOMRectList: 0,
        DOMStringList: 0,
        DOMTokenList: 1,
        DataTransferItemList: 0,
        FileList: 0,
        HTMLAllCollection: 0,
        HTMLCollection: 0,
        HTMLFormElement: 0,
        HTMLSelectElement: 0,
        MediaList: 0,
        MimeTypeArray: 0,
        NamedNodeMap: 0,
        NodeList: 1,
        PaintRequestList: 0,
        Plugin: 0,
        PluginArray: 0,
        SVGLengthList: 0,
        SVGNumberList: 0,
        SVGPathSegList: 0,
        SVGPointList: 0,
        SVGStringList: 0,
        SVGTransformList: 0,
        SourceBufferList: 0,
        StyleSheetList: 0,
        TextTrackCueList: 0,
        TextTrackList: 0,
        TouchList: 0
    }
}, function (t, e, i) {
    var n = i(5);
    e.f = n
}, function (t, e, i) {
    var n = i(71), r = i(4), o = i(84), a = i(9).f;
    t.exports = function (t) {
        var e = n.Symbol || (n.Symbol = {});
        r(e, t) || a(e, t, {value: o.f(t)})
    }
}, function (t, e, i) {
    "use strict";
    var n = i(0), r = i(113), o = i(44), a = i(89), s = i(60), l = i(8), c = i(30), u = i(5), f = i(31), p = i(61),
        d = i(87), h = d.IteratorPrototype, v = d.BUGGY_SAFARI_ITERATORS, g = u("iterator"), m = function () {
            return this
        };
    t.exports = function (t, e, i, u, d, b, y) {
        r(i, e, u);
        var S, w, k, C = function (t) {
                if (t === d && T) return T;
                if (!v && t in _) return _[t];
                switch (t) {
                    case"keys":
                    case"values":
                    case"entries":
                        return function () {
                            return new i(this, t)
                        }
                }
                return function () {
                    return new i(this)
                }
            }, x = e + " Iterator", O = !1, _ = t.prototype, P = _[g] || _["@@iterator"] || d && _[d], T = !v && P || C(d),
            E = "Array" == e && _.entries || P;
        if (E && (S = o(E.call(new t)), h !== Object.prototype && S.next && (f || o(S) === h || (a ? a(S, h) : "function" != typeof S[g] && l(S, g, m)), s(S, x, !0, !0), f && (p[x] = m))), "values" == d && P && "values" !== P.name && (O = !0, T = function () {
            return P.call(this)
        }), f && !y || _[g] === T || l(_, g, T), p[e] = T, d) if (w = {
            values: C("values"),
            keys: b ? T : C("keys"),
            entries: C("entries")
        }, y) for (k in w) (v || O || !(k in _)) && c(_, k, w[k]); else n({target: e, proto: !0, forced: v || O}, w);
        return w
    }
}, function (t, e, i) {
    "use strict";
    var n, r, o, a = i(44), s = i(8), l = i(4), c = i(5), u = i(31), f = c("iterator"), p = !1;
    [].keys && ("next" in (o = [].keys()) ? (r = a(a(o))) !== Object.prototype && (n = r) : p = !0), null == n && (n = {}), u || l(n, f) || s(n, f, (function () {
        return this
    })), t.exports = {IteratorPrototype: n, BUGGY_SAFARI_ITERATORS: p}
}, function (t, e, i) {
    var n = i(2);
    t.exports = !n((function () {
        function t() {
        }

        return t.prototype.constructor = null, Object.getPrototypeOf(new t) !== t.prototype
    }))
}, function (t, e, i) {
    var n = i(10), r = i(114);
    t.exports = Object.setPrototypeOf || ("__proto__" in {} ? function () {
        var t, e = !1, i = {};
        try {
            (t = Object.getOwnPropertyDescriptor(Object.prototype, "__proto__").set).call(i, []), e = i instanceof Array
        } catch (t) {
        }
        return function (i, o) {
            return n(i), r(o), e ? t.call(i, o) : i.__proto__ = o, i
        }
    }() : void 0)
}, function (t, e, i) {
    var n = i(33), r = i(22), o = function (t) {
        return function (e, i) {
            var o, a, s = String(r(e)), l = n(i), c = s.length;
            return l < 0 || l >= c ? t ? "" : void 0 : (o = s.charCodeAt(l)) < 55296 || o > 56319 || l + 1 === c || (a = s.charCodeAt(l + 1)) < 56320 || a > 57343 ? t ? s.charAt(l) : o : t ? s.slice(l, l + 2) : a - 56320 + (o - 55296 << 10) + 65536
        }
    };
    t.exports = {codeAt: o(!1), charAt: o(!0)}
}, function (t, e, i) {
    "use strict";
    var n = i(0), r = i(43).filter, o = i(82), a = i(26), s = o("filter"), l = a("filter");
    n({target: "Array", proto: !0, forced: !s || !l}, {
        filter: function (t) {
            return r(this, t, arguments.length > 1 ? arguments[1] : void 0)
        }
    })
}, function (t, e, i) {
    var n = i(0), r = i(2), o = i(21), a = i(25).f, s = i(6), l = r((function () {
        a(1)
    }));
    n({target: "Object", stat: !0, forced: !s || l, sham: !s}, {
        getOwnPropertyDescriptor: function (t, e) {
            return a(o(t), e)
        }
    })
}, function (t, e, i) {
    var n = i(0), r = i(7), o = i(10), a = i(4), s = i(25), l = i(44);
    n({target: "Reflect", stat: !0}, {
        get: function t(e, i) {
            var n, c, u = arguments.length < 3 ? e : arguments[2];
            return o(e) === u ? e[i] : (n = s.f(e, i)) ? a(n, "value") ? n.value : void 0 === n.get ? void 0 : n.get.call(u) : r(c = l(e)) ? t(c, i, u) : void 0
        }
    })
}, function (t, e, i) {
    var n = i(130);
    t.exports = function (t) {
        if (n(t)) throw TypeError("The method doesn't accept regular expressions");
        return t
    }
}, function (t, e, i) {
    var n = i(5)("match");
    t.exports = function (t) {
        var e = /./;
        try {
            "/./"[t](e)
        } catch (i) {
            try {
                return e[n] = !1, "/./"[t](e)
            } catch (t) {
            }
        }
        return !1
    }
}, function (t, e, i) {
    var n = i(97).default, r = i(111).default, o = i(122).default, a = i(37).default, s = i(64).default,
        l = i(128).default, c = i(132).default, u = i(24).default, f = i(65).default, p = !1, d = function () {
            if (!p) {
                if (p = !0, boostPFSConfig.general.isInitFilter || n.initWithoutFilter(), BoostPFS.Settings.getSettingValue("general.enableAjaxCart")) (new a).refresh();
                if (BoostPFS.Settings.getSettingValue("mostPopular.mostPopularEnable") && jQ(Selector.mostPopular).length > 0) (new l).refresh();
                if (BoostPFS.Settings.getSettingValue("recentlyViewed.recentlyViewedEnable") && jQ(Selector.recentlyViewed).length > 0) (new c).refresh();
                h(window)
            }
        }, h = function (t) {
            t.AddToCart = r, t.QuickView = o, t.AjaxCart = a, t.OTPButtons = n, t.AjaxCartItem = s, t.MostPopular = l, t.RecentlyViewed = c, t.ProductSlider = u, t.ProductSliderItem = f
        }, v = {
            AddToCart: r,
            QuickView: o,
            AjaxCart: a,
            AjaxCartItem: s,
            OTPButtons: n,
            MostPopular: l,
            RecentlyViewed: c,
            ProductSlider: u,
            ProductSliderItem: f,
            init: d,
            reInit: function () {
                p = !1, d()
            },
            inject: h
        };
    t.exports = v
}, function (t, e, i) {
    "use strict";
    i.r(e);
    i(20), i(58), i(106);
    var n = i(3), r = BoostPFS.Selector, o = BoostPFS.Settings, a = function (t) {
        if (o.getSettingValue("actionlist.atcEnable") && (t.addToCart = new BoostOTP.AddToCart, t.addComponent(t.addToCart)), o.getSettingValue("actionlist.qvEnable") || o.getSettingValue("general.enableAjaxCart")) {
            var e = !o.getSettingValue("actionlist.qvEnable");
            t.quickView = new BoostOTP.QuickView(e), t.addComponent(t.quickView)
        }
    }, s = function (t) {
        if (t.quickView && t.quickView.$element || t.addToCart && t.addToCart.$element) {
            var e = '<div class="boost-pfs-action-list-wrapper boost-pfs-action-extend"></div>';
            r.otpButtons ? t.$element.find(r.otpButtons).append(e) : t.$element.append(e), t.$element.addClass("boost-pfs-action-list-enabled"), t.$element.find("img").parent().addClass("boost-pfs-action-overlay"), (t.quickView && !t.addToCart || t.addToCart && !t.quickView || t.addToCart && t.quickView && t.quickView.isHidden) && t.$element.addClass("boost-pfs-action-list-single-button"), (t.quickView && !t.addToCart || t.addToCart && !t.quickView) && t.$element.addClass("boost-pfs-action-list-single-button");
            var i = o.getSettingValue("actionlist.alStyle");
            ["bc-al-style3", "bc-al-style4"].includes(i) ? (t.addToCart && t.addToCart.$element && t.$element.find(".boost-pfs-action-list-wrapper").append(t.addToCart.$element), t.quickView && t.quickView.$element && t.$element.find(".boost-pfs-action-list-wrapper").append(t.quickView.$element)) : (t.quickView && t.quickView.$element && t.$element.find(".boost-pfs-action-list-wrapper").append(t.quickView.$element), t.addToCart && t.addToCart.$element && t.$element.find(".boost-pfs-action-list-wrapper").append(t.addToCart.$element)), t.$productList.hasClass(i) || t.$productList.addClass(i)
        }
    }, l = function (t) {
        t.$element && t.$element.find(".boost-pfs-action-list-wrapper").length > 0 && (c(t), t.$element.on("mouseenter", (function () {
            c(t)
        })))
    }, c = function (t) {
        var e = t.$element.find("img"), i = t.$element.find(".boost-pfs-action-list-wrapper"),
            n = t.$element.outerWidth() - parseInt(t.$element.css("padding-left")) - parseInt(t.$element.css("padding-right"));
        if (e.length > 0 && i.length > 0) {
            var r = t.$element[0].getBoundingClientRect(), a = e[0].getBoundingClientRect(),
                s = i[0].getBoundingClientRect(), l = o.getSettingValue("actionlist.alStyle"), c = 0;
            if ((c = ["bc-al-style5", "bc-al-style6"].includes(l) ? (a.bottom - r.top - s.height) / 2 : a.bottom - r.top - s.height) <= 0) return;
            t.$element.find(".boost-pfs-action-list-wrapper").css({
                top: c + "px",
                width: n + "px",
                visibility: "visible"
            })
        }
    }, u = {
        initWithoutFilter: function () {
            if (r.otpProductItem) {
                var t = new n.a;
                t.data = [], jQ(r.otpProductItem).each((function (e, i) {
                    var r = new n.a;
                    r.$element = jQ(i), r.$productList = r.$element.parent(), r.data = JSON.parse(r.$element.find(".boost-pfs-product-data-json").html()), r.init = function () {
                        a(this)
                    }, r.render = function () {
                        s(this)
                    }, r.bindEvents = function () {
                        l(this)
                    }, t.data.push(r.data), t.addComponent(r)
                })), t.refresh()
            }
        }, init: a, render: s, bindEvents: l, _calculateOTPPosition: c
    };
    e.default = u
}, function (t, e) {
    var i;
    i = function () {
        return this
    }();
    try {
        i = i || new Function("return this")()
    } catch (t) {
        "object" == typeof window && (i = window)
    }
    t.exports = i
}, function (t, e, i) {
    var n = i(1), r = i(68), o = n.WeakMap;
    t.exports = "function" == typeof o && /native code/.test(r(o))
}, function (t, e, i) {
    var n = i(42), r = i(50), o = i(53), a = i(10);
    t.exports = n("Reflect", "ownKeys") || function (t) {
        var e = r.f(a(t)), i = o.f;
        return i ? e.concat(i(t)) : e
    }
}, function (t, e, i) {
    var n = i(2), r = /#|\.prototype\./, o = function (t, e) {
        var i = s[a(t)];
        return i == c || i != l && ("function" == typeof e ? n(e) : !!e)
    }, a = o.normalize = function (t) {
        return String(t).replace(r, ".").toLowerCase()
    }, s = o.data = {}, l = o.NATIVE = "N", c = o.POLYFILL = "P";
    t.exports = o
}, function (t, e, i) {
    var n = i(103);
    t.exports = function (t, e, i) {
        if (n(t), void 0 === e) return t;
        switch (i) {
            case 0:
                return function () {
                    return t.call(e)
                };
            case 1:
                return function (i) {
                    return t.call(e, i)
                };
            case 2:
                return function (i, n) {
                    return t.call(e, i, n)
                };
            case 3:
                return function (i, n, r) {
                    return t.call(e, i, n, r)
                }
        }
        return function () {
            return t.apply(e, arguments)
        }
    }
}, function (t, e) {
    t.exports = function (t) {
        if ("function" != typeof t) throw TypeError(String(t) + " is not a function");
        return t
    }
}, function (t, e, i) {
    var n = i(6), r = i(9), o = i(10), a = i(57);
    t.exports = n ? Object.defineProperties : function (t, e) {
        o(t);
        for (var i, n = a(e), s = n.length, l = 0; s > l;) r.f(t, i = n[l++], e[i]);
        return t
    }
}, function (t, e, i) {
    var n = i(42);
    t.exports = n("document", "documentElement")
}, function (t, e, i) {
    var n = i(0), r = i(107);
    n({global: !0, forced: parseInt != r}, {parseInt: r})
}, function (t, e, i) {
    var n = i(1), r = i(77).trim, o = i(59), a = n.parseInt, s = /^[+-]?0[Xx]/,
        l = 8 !== a(o + "08") || 22 !== a(o + "0x16");
    t.exports = l ? function (t, e) {
        var i = r(String(t));
        return a(i, e >>> 0 || (s.test(i) ? 16 : 10))
    } : a
}, function (t, e, i) {
    "use strict";
    var n = i(38), r = i(9), o = i(28);
    t.exports = function (t, e, i) {
        var a = n(e);
        a in t ? r.f(t, a, o(0, i)) : t[a] = i
    }
}, function (t, e, i) {
    var n, r, o = i(1), a = i(110), s = o.process, l = s && s.versions, c = l && l.v8;
    c ? r = (n = c.split("."))[0] + n[1] : a && (!(n = a.match(/Edge\/(\d+)/)) || n[1] >= 74) && (n = a.match(/Chrome\/(\d+)/)) && (r = n[1]), t.exports = r && +r
}, function (t, e, i) {
    var n = i(42);
    t.exports = n("navigator", "userAgent") || ""
}, function (t, e, i) {
    "use strict";
    i.r(e);
    i(12), i(13), i(14), i(20), i(11), i(15), i(16), i(17), i(27), i(18), i(36), i(19);
    var n = i(3), r = i(37);

    function o(t) {
        return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
            return typeof t
        } : function (t) {
            return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
        })(t)
    }

    function a(t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
    }

    function s(t, e) {
        for (var i = 0; i < e.length; i++) {
            var n = e[i];
            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n)
        }
    }

    function l(t, e) {
        return !e || "object" !== o(e) && "function" != typeof e ? function (t) {
            if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return t
        }(t) : e
    }

    function c(t) {
        return (c = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t)
        })(t)
    }

    function u(t, e) {
        return (u = Object.setPrototypeOf || function (t, e) {
            return t.__proto__ = e, t
        })(t, e)
    }

    var f = BoostPFS.jQ, p = BoostPFS.Labels, d = BoostPFS.Utils, h = BoostPFS.Settings, v = function (t) {
        function e() {
            return a(this, e), l(this, c(e).apply(this, arguments))
        }

        var i, n, o;
        return function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
            t.prototype = Object.create(e && e.prototype, {
                constructor: {
                    value: t,
                    writable: !0,
                    configurable: !0
                }
            }), e && u(t, e)
        }(e, t), i = e, o = [{
            key: "Type", get: function () {
                return {ADD_TO_CART: "add-to-cart", SOLD_OUT: "sold-out", SELECT_OPTIONS: "select-options"}
            }
        }], (n = [{
            key: "getTemplate", value: function () {
                //TCB-171
                
                if(d.isMobile()) {
                    return '\n\t\t\t<form method="post" action="/cart/add" accept-charset="UTF-8" class="{{class.atcForm}}" enctype="multipart/form-data" data-href="{{productUrl}}">\n\t\t\t\t<input type="hidden" name="form_type" value="product">\n\t\t\t\t<div class="js_add_tc"><select name="quantity"><option value="1">1</option><option value="2">2</option><option value="3">3</option><option value="4">4</option><option value="5">5</option><option value="6">6</option><option value="7">7</option><option value="8">8</option><option value="9">9</option><option value="10">10</option></select></div></option>\n\t\t\t\t<input type="hidden" name="id" value="{{variantId}}">\n\t\t\t\t<div class="boost-pfs-addtocart-wrapper">\n\t\t\t\t\t<button name="add" class="boost-pfs-addtocart-btn boost-pfs-addtocart-select-options js-ajax-ct"  data-id="{{variantId}}" {{clickAction}}>\n\t\t\t\t\t\t<span> {{icoCart}}{{label}}</span>\n\t\t\t\t\t</button>\n\t\t\t\t</div>\n\t\t\t</form>\n\t\t'    
                }
                return '\n\t\t\t<form method="post" action="/cart/add" accept-charset="UTF-8" class="{{class.atcForm}}" enctype="multipart/form-data" data-href="{{productUrl}}">\n\t\t\t\t<input type="hidden" name="form_type" value="product">\n\t\t\t\t<div class="js_add_tc"><input type="number" name="quantity" value="1" min="1"></div>\n\t\t\t\t<input type="hidden" name="id" value="{{variantId}}">\n\t\t\t\t<div class="boost-pfs-addtocart-wrapper">\n\t\t\t\t\t<button name="add" class="boost-pfs-addtocart-btn boost-pfs-addtocart-select-options js-ajax-ct" data-id="{{variantId}}" {{clickAction}}>\n\t\t\t\t\t\t<span> {{icoCart}}{{label}}</span>\n\t\t\t\t\t</button>\n\t\t\t\t</div>\n\t\t\t</form>\n\t\t'
            }
        }, {
            key: "compileTemplate", value: function () {
                var t = d.buildProductItemUrl(this.parent.data), i = "", n = "", r = "", o = "", a = this.parent.data,
                    s = this.parent.parent.data, l = a.id == s[0].id;
                return a.available ? 1 == a.variants.length ? (i = h.getSettingValue("general.enableAjaxCart") ? "" : 'type="submit"', r = a.variants[0].id, n = p.action_list.atcAvailableLabel, o = Class.atcAvailable, this.type = e.Type.ADD_TO_CART, this.variantId = r) : (i = h.getSettingValue("general.enableAjaxCart") && !d.isMobile() ? "" : "onclick=\"window.location.href='" + t + '\'" type="button"', n = p.action_list.atcSelectOptionsLabel, o = Class.atcSelectOptions, this.type = e.Type.SELECT_OPTIONS) : (i = 'disabled type="button"', n = p.action_list.atcSoldOutLabel, o = Class.atcSoldOut, this.type = e.Type.SOLD_OUT), this.getTemplate().replace(/{{class.atcForm}}/g, Class.atcForm).replace(/{{label}}/g, n).replace(/{{variantId}}/g, r).replace(/{{clickAction}}/g, i).replace(/{{buttonClass}}/g, o).replace(/{{productUrl}}/g, t).replace(/{{icoCart}}/g, l ? '<svg width="32" height="32" viewBox="0 0 32 32"><g id="boost-pfs-icon-cart" transform="scale(0.03125 0.03125)"><path d="M448.217 818.845c-56.377 0-102.256 45.902-102.256 102.256 0 56.377 45.879 102.256 102.256 102.256s102.256-45.879 102.256-102.256c0-56.379-45.857-102.256-102.256-102.256zM448.217 977.908c-31.312 0-56.807-25.472-56.807-56.807 0-31.312 25.495-56.807 56.807-56.807s56.807 25.495 56.807 56.807c0.003 31.335-25.472 56.807-56.807 56.807z"></path><path d="M768.66 818.845c-56.377 0-102.256 45.902-102.256 102.256 0 56.377 45.879 102.256 102.256 102.256 56.354 0 102.256-45.879 102.256-102.256 0-56.379-45.902-102.256-102.256-102.256zM768.66 977.908c-31.335 0-56.807-25.472-56.807-56.807 0-31.312 25.472-56.807 56.807-56.807 31.29 0 56.807 25.495 56.807 56.807 0.003 31.335-25.517 56.807-56.807 56.807z"></path><path d="M1019.164 259.373c-4.294-5.499-10.886-8.702-17.883-8.702h-768.3l-63.329-233.255c-0.137-0.5-0.5-0.886-0.682-1.364-0.5-1.476-1.25-2.773-2.046-4.090-0.749-1.25-1.431-2.477-2.385-3.545-0.931-1.068-2.021-1.865-3.159-2.726-1.182-0.909-2.317-1.795-3.659-2.454-1.25-0.637-2.591-0.953-3.975-1.364-1.476-0.431-2.907-0.794-4.476-0.909-0.545-0.022-1.001-0.319-1.568-0.319h-124.978c-12.543 0-22.724 10.181-22.724 22.724s10.181 22.724 22.724 22.724h107.595l63.239 232.959 113.572 460.078c2.499 10.156 11.612 17.293 22.065 17.293h558.448c10.452 0 19.543-7.112 22.065-17.293l113.617-460.282c1.7-6.796 0.154-13.955-4.162-19.476zM869.871 710.976h-522.865l-102.39-414.858h727.667l-102.413 414.858z"></path></g></svg>' : '<svg width="32" height="32" viewBox="0 0 32 32"><use xlink:href="#boost-pfs-icon-cart"></use></svg>')
            }
        }, {
            key: "render", value: function () {
                this.$element || (this.$element = f(this.compileTemplate()))
            }
        }, {
            key: "isBindEvents", value: function () {
                return h.getSettingValue("general.enableAjaxCart")
            }
        }, {
            key: "bindEvents", value: function () {
                if (this.$element) switch (this.type) {
                    case e.Type.ADD_TO_CART:
                        this.$element.on("click", this.onClickAddToCart.bind(this));
                        break;
                    case e.Type.SELECT_OPTIONS:
                        d.isMobile() || this.$element.on("click", this.onClickOpenQuickView.bind(this))
                }
            }
        }, {
            key: "onClickAddToCart", value: function (t) {
                t && t.preventDefault();
                var e = this.$element.find(".boost-pfs-addtocart-btn > span"),
                    i = this.parent.$element.find(".boost-pfs-addtocart-error-label");
                i && 0 != i.length || (this.parent.$element.append('<div class="boost-pfs-addtocart-error-label"></div>'), i = this.parent.$element.find(".boost-pfs-addtocart-error-label")), r.default.instance.addToCart(this.variantId, 1, e, i)
            }
        }, {
            key: "onClickOpenQuickView", value: function (t) {
                t && t.preventDefault(), this.parent && this.parent.quickView && this.parent.quickView.$element && (h.getSettingValue("general.selectOptionInProductItem") && this.parent.quickView.$element.attr("data-get-quickview-option", !0), this.parent.quickView.$element.click())
            }
        }]) && s(i.prototype, n), o && s(i, o), e
    }(n.a);
    e.default = v
}, function (t, e, i) {
    var n = i(21), r = i(50).f, o = {}.toString,
        a = "object" == typeof window && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
    t.exports.f = function (t) {
        return a && "[object Window]" == o.call(t) ? function (t) {
            try {
                return r(t)
            } catch (t) {
                return a.slice()
            }
        }(t) : r(n(t))
    }
}, function (t, e, i) {
    "use strict";
    var n = i(87).IteratorPrototype, r = i(56), o = i(28), a = i(60), s = i(61), l = function () {
        return this
    };
    t.exports = function (t, e, i) {
        var c = e + " Iterator";
        return t.prototype = r(n, {next: o(1, i)}), a(t, c, !1, !0), s[c] = l, t
    }
}, function (t, e, i) {
    var n = i(7);
    t.exports = function (t) {
        if (!n(t) && null !== t) throw TypeError("Can't set " + String(t) + " as a prototype");
        return t
    }
}, function (t, e, i) {
    "use strict";
    var n = i(62), r = i(116);
    t.exports = n ? {}.toString : function () {
        return "[object " + r(this) + "]"
    }
}, function (t, e, i) {
    var n = i(62), r = i(29), o = i(5)("toStringTag"), a = "Arguments" == r(function () {
        return arguments
    }());
    t.exports = n ? r : function (t) {
        var e, i, n;
        return void 0 === t ? "Undefined" : null === t ? "Null" : "string" == typeof (i = function (t, e) {
            try {
                return t[e]
            } catch (t) {
            }
        }(e = Object(t), o)) ? i : a ? r(e) : "Object" == (n = r(e)) && "function" == typeof e.callee ? "Arguments" : n
    }
}, function (t, e, i) {
    "use strict";
    var n = i(10);
    t.exports = function () {
        var t = n(this), e = "";
        return t.global && (e += "g"), t.ignoreCase && (e += "i"), t.multiline && (e += "m"), t.dotAll && (e += "s"), t.unicode && (e += "u"), t.sticky && (e += "y"), e
    }
}, function (t, e, i) {
    "use strict";
    var n = i(2);

    function r(t, e) {
        return RegExp(t, e)
    }

    e.UNSUPPORTED_Y = n((function () {
        var t = r("a", "y");
        return t.lastIndex = 2, null != t.exec("abcd")
    })), e.BROKEN_CARET = n((function () {
        var t = r("^r", "gy");
        return t.lastIndex = 2, null != t.exec("str")
    }))
}, function (t, e, i) {
    "use strict";
    i(27);
    var n = i(30), r = i(2), o = i(5), a = i(63), s = i(8), l = o("species"), c = !r((function () {
            var t = /./;
            return t.exec = function () {
                var t = [];
                return t.groups = {a: "7"}, t
            }, "7" !== "".replace(t, "$<a>")
        })), u = "$0" === "a".replace(/./, "$0"), f = o("replace"), p = !!/./[f] && "" === /./[f]("a", "$0"),
        d = !r((function () {
            var t = /(?:)/, e = t.exec;
            t.exec = function () {
                return e.apply(this, arguments)
            };
            var i = "ab".split(t);
            return 2 !== i.length || "a" !== i[0] || "b" !== i[1]
        }));
    t.exports = function (t, e, i, f) {
        var h = o(t), v = !r((function () {
            var e = {};
            return e[h] = function () {
                return 7
            }, 7 != ""[t](e)
        })), g = v && !r((function () {
            var e = !1, i = /a/;
            return "split" === t && ((i = {}).constructor = {}, i.constructor[l] = function () {
                return i
            }, i.flags = "", i[h] = /./[h]), i.exec = function () {
                return e = !0, null
            }, i[h](""), !e
        }));
        if (!v || !g || "replace" === t && (!c || !u || p) || "split" === t && !d) {
            var m = /./[h], b = i(h, ""[t], (function (t, e, i, n, r) {
                return e.exec === a ? v && !r ? {done: !0, value: m.call(e, i, n)} : {
                    done: !0,
                    value: t.call(i, e, n)
                } : {done: !1}
            }), {REPLACE_KEEPS_$0: u, REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE: p}), y = b[0], S = b[1];
            n(String.prototype, t, y), n(RegExp.prototype, h, 2 == e ? function (t, e) {
                return S.call(t, this, e)
            } : function (t) {
                return S.call(t, this)
            })
        }
        f && s(RegExp.prototype[h], "sham", !0)
    }
}, function (t, e, i) {
    "use strict";
    var n = i(90).charAt;
    t.exports = function (t, e, i) {
        return e + (i ? n(t, e).length : 1)
    }
}, function (t, e, i) {
    var n = i(29), r = i(63);
    t.exports = function (t, e) {
        var i = t.exec;
        if ("function" == typeof i) {
            var o = i.call(t, e);
            if ("object" != typeof o) throw TypeError("RegExp exec method returned something other than an Object or null");
            return o
        }
        if ("RegExp" !== n(t)) throw TypeError("RegExp#exec called on incompatible receiver");
        return r.call(t, e)
    }
}, function (t, e, i) {
    "use strict";
    i.r(e);
    i(12), i(13), i(14), i(91), i(20), i(34), i(58), i(11), i(123), i(124), i(15), i(16), i(17), i(126), i(27), i(18), i(36), i(35), i(19);
    var n = i(3), r = i(37);

    function o(t) {
        return (o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
            return typeof t
        } : function (t) {
            return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
        })(t)
    }

    function a(t, e) {
        for (var i = 0; i < e.length; i++) {
            var n = e[i];
            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n)
        }
    }

    function s(t, e) {
        return !e || "object" !== o(e) && "function" != typeof e ? function (t) {
            if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return t
        }(t) : e
    }

    function l(t) {
        return (l = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t)
        })(t)
    }

    function c(t, e) {
        return (c = Object.setPrototypeOf || function (t, e) {
            return t.__proto__ = e, t
        })(t, e)
    }

    var u = BoostPFS.Labels, f = BoostPFS.jQ, p = BoostPFS.Settings, d = BoostPFS.Utils, h = function (t) {
        function e(t) {
            var i;
            return function (t, e) {
                if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
            }(this, e), (i = s(this, l(e).call(this))).isHidden = t, i
        }

        var i, n, o;
        return function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
            t.prototype = Object.create(e && e.prototype, {
                constructor: {
                    value: t,
                    writable: !0,
                    configurable: !0
                }
            }), e && c(t, e)
        }(e, t), i = e, (n = [{
            key: "getTemplate", value: function () {
                return '\n\t\t\t<button class="boost-pfs-quickview-btn boost-pfs-filter-button" {{hiddenStyle}} data-href="{{productUrl}}" aria-label="{{label.quickview}}">\n\t\t\t\t<span>\n\t\t\t\t\t{{icoQuickView}}\n\t\t\t\t</span>\n\t\t\t</button>\n\t\t'
            }
        }, {
            key: "getModalTemplate", value: function () {
                return '\n\t\t\t<div class="boost-pfs-modal-backdrop">\n\t\t\t\t<div class="boost-pfs-modal-container">\n\t\t\t\t\t<div class="boost-pfs-modal-content"></div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t'
            }
        }, {
            key: "compileTemplate", value: function () {
                var t = this.parent.data, e = this.parent.parent.data, i = t.id == e[0].id,
                    n = '<svg width="32" height="32" viewBox="0 0 32 32"><g id="boost-pfs-icon-quick-view" transform="scale(0.03125 0.03125)"><path d="M1009.004 493.256c-2.256-2.82-56.254-69.828-143.786-137.492-51.696-39.962-104.462-71.87-156.832-94.834-66.48-29.152-132.556-43.932-196.386-43.932-63.832 0-129.904 14.782-196.386 43.932-52.37 22.962-105.136 54.87-156.834 94.834-87.53 67.666-141.528 134.674-143.784 137.494l-14.996 18.742 14.998 18.744c2.256 2.82 56.252 69.828 143.784 137.492 51.696 39.962 104.462 71.87 156.834 94.834 66.48 29.152 132.554 43.932 196.386 43.932 63.83 0 129.904-14.782 196.386-43.932 52.37-22.962 105.136-54.87 156.832-94.834 87.53-67.666 141.53-134.674 143.786-137.492l14.994-18.744-14.996-18.744zM827.402 621.624c-74.24 57.196-189.226 125.374-315.402 125.374-126.18 0-241.162-68.178-315.402-125.374-55.36-42.65-97.042-85.794-118.512-109.612 52.994-58.698 229.246-235.006 433.916-235.006 126.178 0 241.162 68.178 315.402 125.374 55.366 42.654 97.050 85.8 118.522 109.622-21.474 23.82-63.158 66.968-118.524 109.622z"></path><path d="M512 309.976c-111.396 0-202.024 90.63-202.024 202.024s90.63 202.024 202.024 202.024 202.026-90.628 202.026-202.024-90.63-202.024-202.026-202.024zM512 654.018c-78.308 0-142.018-63.71-142.018-142.018s63.71-142.018 142.018-142.018 142.018 63.71 142.018 142.018c0 78.308-63.71 142.018-142.018 142.018z"></path><path d="M512 419.322c-51.102 0-92.678 41.576-92.678 92.678s41.576 92.68 92.678 92.68 92.678-41.576 92.678-92.68c0-51.104-41.574-92.678-92.678-92.678zM512 544.672c-18.014 0-32.67-14.656-32.67-32.672s14.656-32.67 32.67-32.67 32.67 14.656 32.67 32.67c0.002 18.014-14.654 32.672-32.67 32.672z"></path></g></svg>',
                    r = '<svg width="32" height="32" viewBox="0 0 32 32"><use xlink:href="#boost-pfs-icon-quick-view"></use></svg>';
                "bc-al-style6" == p.getSettingValue("actionlist.alStyle") && (n = u.action_list.qvBtnLabel, r = u.action_list.qvBtnLabel);
                var o = d.buildProductItemUrl(this.parent.data) + "?view=boost-pfs-quickview";
                return this.getTemplate().replace(/{{label.quickview}}/g, u.action_list.qvBtnLabel).replace(/{{productUrl}}/g, o).replace(/{{icoQuickView}}/g, i ? n : r).replace(/{{hiddenStyle}}/g, this.isHidden ? 'style="display:none;"' : "")
            }
        }, {
            key: "render", value: function () {
                this.$element || (this.$element = f(this.compileTemplate()))
            }
        }, {
            key: "bindEvents", value: function () {
                this.$element && this.$element.on("click", this.getQuickViewModalContent.bind(this))
            }
        }, {
            key: "getQuickViewModalContent", value: function (t) {
                if (t) {
                    t.stopPropagation(), t.preventDefault();
                    var e = f(t.currentTarget).data("href");
                    this.isGetQuickViewOption = !!f(t.currentTarget).attr("data-get-quickview-option"), f(".boost-pfs-select-option-wrapper").remove(), f(".boost-pfs-select-option-show").removeClass("boost-pfs-select-option-show"), this.isGetQuickViewOption ? (f(t.currentTarget).removeAttr("data-get-quickview-option"), e += "-option", this.parent.$element.addClass("boost-pfs-select-option-show")) : (this.$element.closest(".boost-pfs-action-list-wrapper").css("visibility", "hidden"), this.renderQuickViewBackdrop());
                    var i = new XMLHttpRequest;
                    i.open("GET", e), i.setRequestHeader("Content-Type", "text/html;charset=UTF-8"), i.onload = function () {
                        i.readyState > 3 && 200 == i.status && (this.renderQuickViewModal(i.responseText), this.bindQuickViewModalEvents())
                    }.bind(this), i.send(), boostPFS.filter && !this.isGetQuickViewOption && boostPFS.filter.filterLoadingIcon.setShow(!0)
                }
            }
        }, {
            key: "renderQuickViewBackdrop", value: function () {
                0 == f(".boost-pfs-modal-backdrop").length && (f("body").append(this.getModalTemplate()), f(".boost-pfs-modal-backdrop").on("click", this.closeModal.bind(this))), f(".boost-pfs-modal-backdrop").show(), f(".boost-pfs-modal-container").hide(), f("body").addClass("boost-pfs-body-no-scroll"), f("html").addClass("boost-pfs-body-no-scroll")
            }
        }, {
            key: "renderQuickViewModal", value: function (t) {
                if (boostPFS.filter && boostPFS.filter.filterLoadingIcon.setShow(!1), this.isGetQuickViewOption) {
                    var e = this.parent.$element;
                    p.getSettingValue("general.selectOptionContainer") && (e = this.parent.$element.find(p.getSettingValue("general.selectOptionContainer"))), e.length > 0 && (e.find(".boost-pfs-select-option-wrapper").remove(), e.append('<div class="boost-pfs-select-option-wrapper"><div class="boost-pfs-select-option-close"></div>' + t + "</div>"))
                } else f(".boost-pfs-modal-content").html(t), f(".boost-pfs-modal-container").show()
            }
        }, {
            key: "bindQuickViewModalEvents", value: function () {
                this.isGetQuickViewOption ? (p.getSettingValue("general.enableAjaxCart") && this.parent.$element.find("#boost-pfs-quickview-cart-form-" + this.parent.data.id).on("submit", this.onClickAddToCart.bind(this)), f(".boost-pfs-select-option-close").on("click", (function () {
                    f(".boost-pfs-select-option-wrapper").hide(), f(".boost-pfs-action-list-enabled").removeClass("boost-pfs-select-option-show")
                }))) : (this.initImageSlider(), f(".boost-pfs-quickview-close").on("click", this.closeModal.bind(this)), f(".boost-pfs-quickview-select-option").on("change", this.onChangeVariant.bind(this)), f(".boost-pfs-quickview-select-option-color").on("change", this.onChangeVariant.bind(this)), f(".boost-pfs-swatch-element label").on("keydown", (function (t) {
                    !t.target || 13 != t.keyCode && 32 != t.keyCode || f(t.target).click()
                })), p.getSettingValue("general.enableAjaxCart") && f("#boost-pfs-quickview-cart-form").on("submit", this.onClickAddToCart.bind(this)), f(".boost-pfs-quickview-close").focus())
            }
        }, {
            key: "closeModal", value: function (t) {
                var e = this, i = f(t.target);
                (i.hasClass("boost-pfs-modal-backdrop") || i.hasClass("boost-pfs-modal-container") || i.hasClass("boost-pfs-quickview-close")) && (f(".boost-pfs-modal-backdrop").hide(), f(".boost-pfs-modal-container").hide(), f("body").removeClass("boost-pfs-body-no-scroll"), f("html").removeClass("boost-pfs-body-no-scroll"), f("body").hasClass("boost-pfs-ada") && this.parent.$element && (this.parent.$element.find(".boost-pfs-action-list-wrapper").css({visibility: "visible"}), setTimeout((function () {
                    console.log(e.$element), e.$element.focus()
                }), 200)))
            }
        }, {
            key: "initImageSlider", value: function () {
                var t = f(".boost-pfs-quickview-featured-image-wrapper"), e = f(".boost-pfs-quickview-featured-image"),
                    i = f(".boost-pfs-quickview-slider-prev"), n = f(".boost-pfs-quickview-slider-next"),
                    r = f(".boost-pfs-quickview-slider-dot");
                0 != t.length && 0 != e.length && (this.imageSlider = {
                    $itemsWrapper: t,
                    $prev: i,
                    $next: n,
                    $dots: r,
                    posX1: 0,
                    posX2: 0,
                    posInitial: 0,
                    posFinal: 0,
                    threshold: 50,
                    slidesLength: e.length,
                    slideSize: e[0].offsetWidth,
                    index: 0,
                    allowShift: !0,
                    isDragging: !1
                }, 0 == this.imageSlider.index && this.imageSlider.$prev.addClass("disabled"), this.imageSlider.index == this.imageSlider.slidesLength - 1 && this.imageSlider.$next.addClass("disabled"), this.imageSlider.$itemsWrapper.css("left", "0px"), this.imageSlider.$dots.first().addClass("active"), this.imageSlider.$itemsWrapper.on("mousedown", this.dragStart.bind(this)), f(document).off("mousemove"), f(document).off("mouseup"), f(document).on("mousemove", this.dragAction.bind(this)), f(document).on("mouseup", this.dragEnd.bind(this)), this.imageSlider.$prev.on("click", this.shiftSlide.bind(this, null, -1)), this.imageSlider.$next.on("click", this.shiftSlide.bind(this, null, 1)), this.imageSlider.$dots.on("click", function (t) {
                    var e = f(t.currentTarget).data("index");
                    this.shiftSlide(e, null)
                }.bind(this)))
            }
        }, {
            key: "dragStart", value: function (t) {
                (t = t || window.event).preventDefault(), this.imageSlider.posInitial = this.imageSlider.$itemsWrapper[0].offsetLeft, this.imageSlider.posX1 = t.clientX, this.imageSlider.isDragging = !0
            }
        }, {
            key: "dragAction", value: function (t) {
                if (this.imageSlider.isDragging) {
                    t = t || window.event, this.imageSlider.posX2 = this.imageSlider.posX1 - t.clientX, this.imageSlider.posX1 = t.clientX;
                    var e = this.imageSlider.$itemsWrapper[0].offsetLeft - this.imageSlider.posX2,
                        i = .2 * this.imageSlider.slideSize,
                        n = -this.imageSlider.slideSize * (this.imageSlider.slidesLength - .8);
                    e > i ? e = i : e < n && (e = n), this.imageSlider.$itemsWrapper.css("left", e + "px")
                }
            }
        }, {
            key: "dragEnd", value: function (t) {
                this.imageSlider.isDragging && (this.imageSlider.isDragging = !1, this.imageSlider.posFinal = this.imageSlider.$itemsWrapper[0].offsetLeft, this.imageSlider.posFinal - this.imageSlider.posInitial < -this.imageSlider.threshold ? this.shiftSlide(null, 1) : this.imageSlider.posFinal - this.imageSlider.posInitial > this.imageSlider.threshold ? this.shiftSlide(null, -1) : this.imageSlider.$itemsWrapper.css("left", this.imageSlider.posInitial + "px"))
            }
        }, {
            key: "shiftSlide", value: function (t, e) {
                if (null == t && (t = this.imageSlider.index + e), this.imageSlider.allowShift) {
                    var i, n = this.imageSlider.$itemsWrapper.css("left");
                    t > -1 && t < this.imageSlider.slidesLength ? (i = -1 * t * this.imageSlider.slideSize + "px", this.imageSlider.index = t) : i = -1 * this.imageSlider.index * this.imageSlider.slideSize + "px", n != i && (0 == this.imageSlider.index ? this.imageSlider.$prev.addClass("disabled") : this.imageSlider.$prev.removeClass("disabled"), this.imageSlider.index == this.imageSlider.slidesLength - 1 ? this.imageSlider.$next.addClass("disabled") : this.imageSlider.$next.removeClass("disabled"), this.imageSlider.$dots.removeClass("active"), this.imageSlider.$dots.eq(this.imageSlider.index).addClass("active"), this.imageSlider.$itemsWrapper.addClass("boost-pfs-quickview-slider-shifting"), this.imageSlider.$itemsWrapper.css("left", i), this.imageSlider.allowShift = !1, setTimeout(this.afterShiftSlide.bind(this), 300))
                }
            }
        }, {
            key: "afterShiftSlide", value: function () {
                this.imageSlider.$itemsWrapper.removeClass("boost-pfs-quickview-slider-shifting"), this.imageSlider.allowShift = !0
            }
        }, {
            key: "onClickAddToCart", value: function (t) {
                t && t.preventDefault();
                var e = this._getSelectedVariant(), i = 1, n = null, o = null;
                this.isGetQuickViewOption ? (n = f(".boost-pfs-quickview-cart-btn-text"), o = f(".boost-pfs-select-option-wrapper .boost-pfs-addtocart-error-label")) : (i = f("#boost-pfs-quickview-cart-quantity").val(), n = f("#boost-pfs-quickview-cart-btn-text"), o = f("#boost-pfs-addtocart-error-label")), e && r.default.instance.addToCart(e.id, i, n, o)
            }
        }, {
            key: "onChangeVariant", value: function () {
                var t = this._getSelectedVariant();
                this._updateQuickViewModal(t), null != t && t.image && f('.boost-pfs-quickview-slider-dot[data-image="' + d.optimizeImage(t.image, "small").replace("https:", "") + '"]').click()
            }
        }, {
            key: "_getSelectedVariant", value: function () {
                var t = ["option1", "option2", "option3"], e = null;
                e = this.isGetQuickViewOption ? f("#boost-pfs-quickview-cart-form-" + this.parent.data.id).serializeArray() : f("#boost-pfs-quickview-cart-form").serializeArray();
                var i = [];
                e.forEach((function (e) {
                    t.includes(e.name) && i.push(e)
                }));
                var n = [];
                n = this.isGetQuickViewOption ? JSON.parse(f(".boost-pfs-quickview-variants-data-" + this.parent.data.id).html()) : JSON.parse(f("#boost-pfs-quickview-variants-data").html());
                var r = null;
                if (n.forEach((function (t) {
                    if (!r) {
                        var e = !0;
                        i.forEach((function (i) {
                            if (e) {
                                var n = t[i.name], r = i.value;
                                null != n && null != r && n != r && (e = !1)
                            }
                        })), e && (r = t)
                    }
                })), r && r.id && this.parent && this.parent.data && Array.isArray(this.parent.data.variants)) {
                    var o = this.parent.data.variants.find((function (t) {
                        return t.id == r.id
                    }));
                    o && Object.assign(r, o)
                }
                return r
            }
        }, {
            key: "_updateQuickViewModal", value: function (t) {
                var e = f("#boost-pfs-quickview-variants-selector"), i = f("#boost-pfs-quickview-cart-btn"),
                    n = f("#boost-pfs-quickview-cart-btn-text"), r = f(".boost-pfs-quickview-price-wrapper");
                if (t && t.available) {
                    e.val(t.id), i.removeAttr("disabled"), n.html(u.action_list.qvAddToCartBtnLabel);
                    var o = e.find(":selected"), a = o.data("current-price"), s = o.data("was-price"),
                        l = o.data("current-price-without-currency");
                    l && "string" == typeof l && (l = l.replace(/[ ,.]/g, ""));
                    var c = o.data("was-price-without-currency");
                    c && "string" == typeof c && (c = c.replace(/[ ,.]/g, ""));
                    var p = !1;
                    l && c && (p = parseFloat(c) > parseFloat(l)), p ? (f("#boost-pfs-quickview-current-price").html(a), f("#boost-pfs-quickview-was-price").html(s), r.addClass("boost-pfs-quickview-price-on-sale")) : (f("#boost-pfs-quickview-current-price").html(a), f("#boost-pfs-quickview-was-price").html(""), r.removeClass("boost-pfs-quickview-price-on-sale"))
                } else i.attr("disabled", !0), n.html(u.action_list.qvSoldOutLabel)
            }
        }]) && a(i.prototype, n), o && a(i, o), e
    }(n.a);
    e.default = h
}, function (t, e, i) {
    var n = i(6), r = i(9).f, o = Function.prototype, a = o.toString, s = /^\s*function ([^ (]*)/;
    n && !("name" in o) && r(o, "name", {
        configurable: !0, get: function () {
            try {
                return a.call(this).match(s)[1]
            } catch (t) {
                return ""
            }
        }
    })
}, function (t, e, i) {
    var n = i(0), r = i(125);
    n({target: "Object", stat: !0, forced: Object.assign !== r}, {assign: r})
}, function (t, e, i) {
    "use strict";
    var n = i(6), r = i(2), o = i(57), a = i(53), s = i(45), l = i(23), c = i(46), u = Object.assign,
        f = Object.defineProperty;
    t.exports = !u || r((function () {
        if (n && 1 !== u({b: 1}, u(f({}, "a", {
            enumerable: !0, get: function () {
                f(this, "b", {value: 3, enumerable: !1})
            }
        }), {b: 2})).b) return !0;
        var t = {}, e = {}, i = Symbol();
        return t[i] = 7, "abcdefghijklmnopqrst".split("").forEach((function (t) {
            e[t] = t
        })), 7 != u({}, t)[i] || "abcdefghijklmnopqrst" != o(u({}, e)).join("")
    })) ? function (t, e) {
        for (var i = l(t), r = arguments.length, u = 1, f = a.f, p = s.f; r > u;) for (var d, h = c(arguments[u++]), v = f ? o(h).concat(f(h)) : o(h), g = v.length, m = 0; g > m;) d = v[m++], n && !p.call(h, d) || (i[d] = h[d]);
        return i
    } : u
}, function (t, e, i) {
    var n = i(0), r = i(127);
    n({global: !0, forced: parseFloat != r}, {parseFloat: r})
}, function (t, e, i) {
    var n = i(1), r = i(77).trim, o = i(59), a = n.parseFloat, s = 1 / a(o + "-0") != -1 / 0;
    t.exports = s ? function (t) {
        var e = r(String(t)), i = a(e);
        return 0 === i && "-" == e.charAt(0) ? -0 : i
    } : a
}, function (t, e, i) {
    "use strict";
    i.r(e);
    i(12), i(13), i(14), i(34), i(11), i(92), i(15), i(16), i(17), i(93), i(27), i(18), i(36), i(129), i(35), i(19);
    var n = i(24);

    function r(t) {
        return (r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
            return typeof t
        } : function (t) {
            return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
        })(t)
    }

    function o(t, e) {
        for (var i = 0; i < e.length; i++) {
            var n = e[i];
            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n)
        }
    }

    function a(t, e) {
        return !e || "object" !== r(e) && "function" != typeof e ? function (t) {
            if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return t
        }(t) : e
    }

    function s(t, e, i) {
        return (s = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (t, e, i) {
            var n = function (t, e) {
                for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = l(t));) ;
                return t
            }(t, e);
            if (n) {
                var r = Object.getOwnPropertyDescriptor(n, e);
                return r.get ? r.get.call(i) : r.value
            }
        })(t, e, i || t)
    }

    function l(t) {
        return (l = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t)
        })(t)
    }

    function c(t, e) {
        return (c = Object.setPrototypeOf || function (t, e) {
            return t.__proto__ = e, t
        })(t, e)
    }

    var u = BoostPFS.jQ, f = BoostPFS.Selector, p = BoostPFS.Labels, d = function (t) {
        function e() {
            var t;
            return function (t, e) {
                if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
            }(this, e), (t = a(this, l(e).call(this))).type = n.default.ProductSliderType.MOST_POPULAR, t.selector = f.mostPopular, t.header = p.mostPopular.popularProductsHeading, t.productSliderRange = Settings.getSettingValue("mostPopular.popularProductSliderRange"), t.productSliderRange <= 0 && (t.productSliderRange = 5), t.isFetchedMostPopularData = !1, t.collectionHandle = boostPFSAppConfig.general.collection_handle ? boostPFSAppConfig.general.collection_handle : "all", t
        }

        var i, r, d;
        return function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
            t.prototype = Object.create(e && e.prototype, {
                constructor: {
                    value: t,
                    writable: !0,
                    configurable: !0
                }
            }), e && c(t, e)
        }(e, t), i = e, (r = [{
            key: "init", value: function () {
                var t = this,
                    e = "/collections/" + this.collectionHandle + "?view=boost-pfs-most-popular&sort_by=best-selling";
                u.ajax({
                    type: "GET", url: e, success: function (e) {
                        var i = null;
                        try {
                            /<\!--.*?-->/.test(e) && (e = e.replace(/<\!--.*?-->/g, "")), i = t.prepareData(JSON.parse(e))
                        } catch (t) {
                            throw new Error("Could not parse json from collection.boost-pfs-most-popular.liquid")
                        }
                        t.isFetchedMostPopularData = !0, t.setData(i, !0)
                    }, error: function (t) {
                        throw new Error("Error getting most popular: " + t.status + " " + t.statusText)
                    }
                })
            }
        }, {
            key: "prepareData", value: function (t) {
                return t.products.forEach((function (t) {
                    t.price /= 100, t.price_min /= 100, t.price_max /= 100, t.compare_at_price /= 100, t.compare_at_price_min /= 100, t.compare_at_price_max /= 100, t.variants.forEach((function (t) {
                        t.price /= 100, t.compare_at_price /= 100
                    }))
                })), t
            }
        }, {
            key: "isRender", value: function () {
                return this.isFetchedMostPopularData && this.data.products.length > 0
            }
        }, {
            key: "isBindEvents", value: function () {
                return this.$element
            }
        }, {
            key: "isLoopThroughChild", value: function () {
                return this.isFetchedMostPopularData && this.data.products.length > 0
            }
        }, {
            key: "bindEvents", value: function () {
                s(l(e.prototype), "bindEvents", this).call(this), boostPFSConfig.general.isInitFilter && u(window).on("boost-pfs-change-address-bar", this.updateMostPopularData.bind(this))
            }
        }, {
            key: "updateMostPopularData", value: function () {
                if (window.location.pathname.startsWith("/collections/")) {
                    var t = window.location.pathname.replace("/collections/", "");
                    t && t != this.collectionHandle && (this.collectionHandle = t, this.isFetchedMostPopularData = !1, this.isInit = !1, this.refresh())
                }
            }
        }]) && o(i.prototype, r), d && o(i, d), e
    }(n.default);
    e.default = d
}, function (t, e, i) {
    "use strict";
    var n, r = i(0), o = i(25).f, a = i(32), s = i(94), l = i(22), c = i(95), u = i(31), f = "".startsWith,
        p = Math.min, d = c("startsWith");
    r({
        target: "String",
        proto: !0,
        forced: !!(u || d || (n = o(String.prototype, "startsWith"), !n || n.writable)) && !d
    }, {
        startsWith: function (t) {
            var e = String(l(this));
            s(t);
            var i = a(p(arguments.length > 1 ? arguments[1] : void 0, e.length)), n = String(t);
            return f ? f.call(e, n, i) : e.slice(i, i + n.length) === n
        }
    })
}, function (t, e, i) {
    var n = i(7), r = i(29), o = i(5)("match");
    t.exports = function (t) {
        var e;
        return n(t) && (void 0 !== (e = t[o]) ? !!e : "RegExp" == r(t))
    }
}, function (t, e, i) {
    "use strict";
    var n = i(0), r = i(94), o = i(22);
    n({target: "String", proto: !0, forced: !i(95)("includes")}, {
        includes: function (t) {
            return !!~String(o(this)).indexOf(r(t), arguments.length > 1 ? arguments[1] : void 0)
        }
    })
}, function (t, e, i) {
    "use strict";
    i.r(e);
    i(12), i(13), i(14), i(91), i(20), i(80), i(11), i(81), i(92), i(15), i(16), i(17), i(93), i(18), i(19);
    var n = i(24);

    function r(t) {
        return (r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
            return typeof t
        } : function (t) {
            return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
        })(t)
    }

    function o(t, e) {
        for (var i = 0; i < e.length; i++) {
            var n = e[i];
            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n)
        }
    }

    function a(t, e) {
        return !e || "object" !== r(e) && "function" != typeof e ? function (t) {
            if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return t
        }(t) : e
    }

    function s(t, e, i) {
        return (s = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (t, e, i) {
            var n = function (t, e) {
                for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = l(t));) ;
                return t
            }(t, e);
            if (n) {
                var r = Object.getOwnPropertyDescriptor(n, e);
                return r.get ? r.get.call(i) : r.value
            }
        })(t, e, i || t)
    }

    function l(t) {
        return (l = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t)
        })(t)
    }

    function c(t, e) {
        return (c = Object.setPrototypeOf || function (t, e) {
            return t.__proto__ = e, t
        })(t, e)
    }

    var u = BoostPFS.jQ, f = BoostPFS.Labels, p = BoostPFS.Selector, d = function (t) {
        function e() {
            var t;
            return function (t, e) {
                if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
            }(this, e), (t = a(this, l(e).call(this))).type = n.default.ProductSliderType.RECENTLY_VIEWED, t.selector = p.recentlyViewed, t.header = f.recentlyViewed.recentProductHeading, t.productSliderRange = Settings.getSettingValue("recentlyViewed.recentProductSliderRange"), t.limit = Settings.getSettingValue("recentlyViewed.limit"), t.productSliderRange <= 0 && (t.productSliderRange = 3), t.localStorageRecentProductsKey = "boostPFSRecentProducts", t
        }

        var i, r, d;
        return function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
            t.prototype = Object.create(e && e.prototype, {
                constructor: {
                    value: t,
                    writable: !0,
                    configurable: !0
                }
            }), e && c(t, e)
        }(e, t), i = e, (r = [{
            key: "init", value: function () {
                var t = {products: [], ids: []};
                try {
                    var e = JSON.parse(localStorage.getItem(this.localStorageRecentProductsKey));
                    null != e && (t = e)
                } catch (t) {
                    localStorage.setItem(this.localStorageRecentProductsKey, JSON.stringify(this.data))
                }
                this.setData(t, !1)
            }
        }, {
            key: "isRender", value: function () {
                return this.data && this.data.products && this.data.products.length > 0
            }
        }, {
            key: "bindEvents", value: function () {
                s(l(e.prototype), "bindEvents", this).call(this), u(p.products).length > 0 && document.addEventListener("click", this.updateRecentlyViewedData.bind(this), !0)
            }
        }, {
            key: "updateRecentlyViewedData", value: function (t) {
                var e = u(event.target).closest(p.trackingProduct).attr("data-id"), i = this.data.ids.indexOf(e);
                if (boostPFS.filter && -1 == i && (n = boostPFS.filter.filterResult.productList.data.find((function (t) {
                    return t.id == e
                }))) && (this.data.products.unshift(n), this.data.ids.unshift(e), this.data.products.length > this.limit && (this.data.products.pop(), this.data.ids.pop())), i > 0) {
                    var n = this.data.products[i];
                    this.data.ids.splice(i, 1), this.data.ids.unshift(e), this.data.products.splice(i, 1), this.data.products.unshift(n)
                }
                localStorage.setItem(this.localStorageRecentProductsKey, JSON.stringify(this.data))
            }
        }]) && o(i.prototype, r), d && o(i, d), e
    }(n.default);
    e.default = d
}]);
